import { aiDraftsUr } from './ai-drafts/ur';
import { automationsUr } from './automations/ur';
import { blockingUr } from './blocking/ur';
import { cachingUr } from './caching';
import { channelsUr } from './channels/ur';
import { chatWidgetUr } from './chat-widget/ur';
import { checksUr } from './checks';
import { commerceUr } from './commerce/ur';
import { decisionsUr } from './decisions';
import { developerUr } from './developer/ur';
import type { Translation } from './en';
import { offersUr } from './offers/ur';
import { privacyUr } from './privacy/ur';
import { reportsUr } from './reports/ur';
import { slaUr } from './sla/ur';
import { ticketsUr } from './tickets/ur';
import { toolsUr } from './tools';
import { chatSettingsUr } from './widget/ur';

/** Urdu. Pending review by native speakers, as the note in the interface says. */
export const ur: Translation = {
  app: {
    name: 'Hamnivo Studio',
    skipToContent: 'مواد پر جائیں',
    language: 'زبان',
    translationNote: 'اس ترجمے کا ابھی اہلِ زبان سے جائزہ ہونا باقی ہے۔',
    close: 'بند کریں',
    cancel: 'منسوخ کریں',
    retry: 'دوبارہ کوشش کریں',
    reference: 'حوالہ',
    copied: 'کاپی ہو گیا',
    optional: 'اختیاری',
    serverDetail: 'سرور سے: {{detail}}',
    cancelled: 'منسوخ کر دیا گیا۔ کچھ تبدیل نہیں ہوا۔',
    loading: 'لوڈ ہو رہا ہے',
  },
  nav: {
    label: 'Studio',
    home: 'ہوم',
    inbox: 'ان باکس',
    ai: 'AI معاون',
    sales: 'فروخت',
    settings: 'ترتیبات',
    sections: '{{name}} کے صفحات',
    brands: 'برانڈز اور انسٹال',
    agents: 'AI ایجنٹس',
    models: 'ماڈل کنکشنز',
    knowledge: 'معلومات',
    memory: 'کسٹمر میموری',
    runs: 'سرگرمی',
    team: 'ٹیم اور رسائی',
    security: 'سیکیورٹی',
    platform: 'پلیٹ فارم کنسول',
    account: 'اکاؤنٹ کی حفاظت',
    openMenu: 'مینو کھولیں',
    menu: 'مینو',
    switchWorkspace: 'ورک اسپیس بدلیں',
    workspace: 'ورک اسپیس',
    signOut: 'سائن آؤٹ کریں',
    signedInAs: 'اس اکاؤنٹ سے سائن اِن',
  },
  errors: {
    network: {
      title: 'Hamnivo تک رسائی نہیں ہو سکی',
      description: 'اپنا کنکشن چیک کریں اور دوبارہ کوشش کریں۔',
    },
    denied: {
      title: 'آپ کو یہ کرنے کی اجازت نہیں ہے',
      description: 'ورک اسپیس کے مالک یا ایڈمن سے رسائی مانگیں۔',
    },
    notFound: {
      title: 'یہ نہیں ملا',
      description: 'ہو سکتا ہے اسے ہٹا دیا گیا ہو، یا لنک غلط ہو۔',
    },
    validation: {
      title: 'کچھ معلومات پر توجہ درکار ہے',
      description: 'تفصیلات چیک کریں اور دوبارہ کوشش کریں۔',
    },
    rateLimited: {
      title: 'بہت زیادہ درخواستیں',
      description: 'تھوڑا انتظار کریں، پھر دوبارہ کوشش کریں۔',
      retryIn: 'آپ {{seconds}} سیکنڈ بعد دوبارہ کوشش کر سکتے ہیں۔',
      retryNow: 'اب آپ دوبارہ کوشش کر سکتے ہیں۔',
    },
    unavailable: {
      title: 'ایک منسلک سروس جواب نہیں دے رہی',
      description: 'کچھ تبدیل نہیں ہوا۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔',
    },
    idempotency: {
      title: 'یہ پہلے ہی مختلف تفصیلات کے ساتھ بھیجا جا چکا ہے',
      description: 'کیا محفوظ ہوا، یہ دیکھنے کے لیے صفحہ دوبارہ لوڈ کریں۔',
    },
    conflict: {
      title: 'کسی اور نے اسے پہلے تبدیل کر دیا',
      description: 'تازہ ترین ورژن دیکھنے کے لیے دوبارہ لوڈ کریں۔',
    },
    mfa: {
      title: 'دو مرحلہ تصدیق درکار ہے',
      description: 'اکاؤنٹ کی حفاظت میں دو مرحلہ تصدیق آن کریں، پھر دوبارہ کوشش کریں۔',
    },
    tooLarge: { title: 'فائل بہت بڑی ہے', description: 'فائل 5 MB تک ہو سکتی ہے۔' },
    rejected: { title: 'فائل مسترد کر دی گئی', description: 'فائل قبول نہیں کی جا سکی۔' },
    disabled: {
      title: 'یہ فیچر بند ہے',
      description: 'اسے آن کرنے کے لیے اپنے ایڈمن سے کہیں۔',
    },
    internal: {
      title: 'ہماری طرف سے کچھ غلط ہو گیا',
      description: 'کچھ تبدیل نہیں ہوا۔ دوبارہ کوشش کریں۔',
    },
    planLimit: {
      title: 'پلان کی حد پوری ہو گئی',
      description:
        'آپ کے پلان میں اس سے زیادہ شامل نہیں۔ کچھ جگہ خالی کریں، یا ورک اسپیس کے مالک سے بڑے پلان کے بارے میں پوچھیں۔',
    },
    reauth: {
      title: 'جاری رکھنے کے لیے دوبارہ سائن اِن کریں',
      description: 'آپ کی حفاظت کے لیے، اس کے لیے حالیہ سائن اِن ضروری ہے۔',
      action: 'دوبارہ سائن اِن کریں',
    },
    channelWindow: {
      title: 'اب صرف ٹیمپلیٹ پیغامات بھیجے جا سکتے ہیں',
      description:
        'واٹس ایپ گاہک کے آخری پیغام کے بعد 24 گھنٹے تک ہی جواب دینے دیتا ہے۔ کچھ نہیں بھیجا گیا۔ گاہک کے دوبارہ لکھنے کے بعد آپ پھر جواب دے سکتے ہیں۔',
    },
    unknown: { title: 'کچھ غلط ہو گیا', description: 'دوبارہ کوشش کریں۔' },
    page: {
      title: 'یہ صفحہ لوڈ نہیں ہو سکا',
      description: 'دوبارہ کوشش کریں۔ اگر ایسا بار بار ہو تو صفحہ دوبارہ لوڈ کریں۔',
    },
  },
  states: {
    stale: {
      since: 'اسے تازہ نہیں کیا جا سکا۔ {{time}} لوڈ کیا گیا ڈیٹا دکھایا جا رہا ہے۔',
      unknown: 'اسے تازہ نہیں کیا جا سکا۔ جو نظر آ رہا ہے وہ پرانا ہو سکتا ہے۔',
    },
    forbiddenTitle: 'آپ کو اس صفحے تک رسائی نہیں ہے',
    forbiddenDescription: 'ورک اسپیس کے مالک یا ایڈمن سے رسائی دینے کو کہیں۔',
    backToOverview: 'جائزے پر واپس جائیں',
    notFoundTitle: 'صفحہ نہیں ملا',
    notFoundDescription: 'ہو سکتا ہے پتہ غلط ہو، یا صفحہ کہیں اور منتقل ہو گیا ہو۔',
  },
  auth: {
    email: 'ای میل پتہ',
    password: 'پاس ورڈ',
    showPassword: 'پاس ورڈ دکھائیں',
    hidePassword: 'پاس ورڈ چھپائیں',
    errorSummary: 'آگے بڑھنے کے لیے انہیں درست کریں',
    emailRequired: 'اپنا ای میل پتہ درج کریں۔',
    emailInvalid: 'name@example.com جیسا ای میل پتہ درج کریں۔',
    passwordRequired: 'اپنا پاس ورڈ درج کریں۔',
    rateLimited: 'بہت زیادہ کوششیں۔ چند منٹ انتظار کریں، پھر دوبارہ کوشش کریں۔',
    privacy:
      'Studio ایک محفوظ کوکی کے ذریعے آپ کو سائن اِن رکھتا ہے۔ آپ جو لکھتے ہیں وہ محفوظ کرنے تک اسی ٹیب میں رہتا ہے۔',
    signIn: {
      title: 'خوش آمدید',
      description: 'جاری رکھنے کے لیے Hamnivo Studio میں سائن اِن کریں۔',
      keepSignedIn: 'اس ڈیوائس پر مجھے سائن اِن رکھیں',
      keepSignedInHint:
        'مشترکہ کمپیوٹر پر اسے بند رکھیں۔ تب براؤزر بند ہونے پر آپ سائن آؤٹ ہو جائیں گے۔',
      submit: 'سائن اِن کریں',
      or: 'یا',
      passkey: 'پاس کی سے سائن اِن کریں',
      forgot: 'پاس ورڈ بھول گئے؟',
      noAccount: 'Hamnivo پر نئے ہیں؟',
      createAccount: 'اکاؤنٹ بنائیں',
      failed:
        'آپ کو سائن اِن نہیں کیا جا سکا۔ اپنا ای میل اور پاس ورڈ چیک کریں، یا پاس ورڈ ری سیٹ کریں۔',
      notVerified:
        'پہلے اپنے ای میل پتے کی تصدیق کریں۔ سائن اپ کے وقت ہم نے آپ کو ایک لنک بھیجا تھا۔',
      resendVerification: 'لنک دوبارہ بھیجیں',
      verificationSent: 'ہم نے نیا لنک بھیج دیا ہے۔ اپنی ای میل دیکھیں۔',
      passkeyFailed: 'پاس کی سے سائن اِن نہیں ہو سکا۔ دوبارہ کوشش کریں، یا پاس ورڈ سے سائن اِن کریں۔',
    },
    twoFactor: {
      title: 'تصدیق کریں کہ یہ آپ ہی ہیں',
      description: 'اپنی تصدیقی ایپ سے 6 ہندسوں کا کوڈ درج کریں۔',
      code: '6 ہندسوں کا کوڈ',
      codeHint: 'کوڈ ہر 30 سیکنڈ میں بدلتا ہے۔',
      submit: 'تصدیق کریں',
      useBackup: 'اس کے بجائے بیک اپ کوڈ استعمال کریں',
      useApp: 'اس کے بجائے ایپ کا کوڈ استعمال کریں',
      backupCode: 'بیک اپ کوڈ',
      backupHint: 'دو مرحلہ تصدیق آن کرتے وقت آپ نے جو کوڈز محفوظ کیے تھے، ان میں سے ایک۔',
      codeRequired: 'کوڈ درج کریں۔',
      invalid: 'یہ کوڈ درست نہیں نکلا۔ اسے چیک کریں اور دوبارہ کوشش کریں۔',
      expired: 'سائن اِن کی یہ کوشش ختم ہو گئی۔ نئی جانچ کے لیے دوبارہ سائن اِن کریں۔',
      tooMany: 'بہت زیادہ کوششیں۔ جاری رکھنے کے لیے دوبارہ سائن اِن کریں۔',
      back: 'سائن اِن پر واپس جائیں',
    },
    signUp: {
      title: 'اپنا اکاؤنٹ بنائیں',
      description:
        'اس کے بعد آپ ایک ورک اسپیس بنا سکتے ہیں، یا اس میں شامل ہو سکتے ہیں جس میں آپ کو مدعو کیا گیا ہے۔',
      name: 'آپ کا نام',
      nameRequired: 'اپنا نام درج کریں۔',
      passwordHint: 'کم از کم 12 حروف۔ ایک چھوٹا جملہ یاد رکھنا آسان ہوتا ہے۔',
      passwordShort: 'کم از کم 12 حروف استعمال کریں۔',
      passwordLong: 'زیادہ سے زیادہ 256 حروف استعمال کریں۔',
      submit: 'اکاؤنٹ بنائیں',
      haveAccount: 'پہلے سے اکاؤنٹ ہے؟',
      signIn: 'سائن اِن کریں',
      failed:
        'یہ اکاؤنٹ نہیں بنایا جا سکا۔ اگر آپ کا پہلے سے اکاؤنٹ ہے تو سائن اِن کریں یا پاس ورڈ ری سیٹ کریں۔',
    },
    checkEmail: {
      title: 'اپنی ای میل دیکھیں',
      verify:
        'ہم نے {{email}} پر ایک لنک بھیجا ہے۔ اپنے پتے کی تصدیق اور سائن اپ مکمل کرنے کے لیے اسے کھولیں۔',
      reset:
        'اگر کوئی اکاؤنٹ {{email}} استعمال کرتا ہے تو ہم نے اس پر نیا پاس ورڈ چننے کا لنک بھیجا ہے۔ لنک ایک گھنٹے تک کام کرتا ہے۔',
      help: 'نہیں ملا؟ اسپیم فولڈر دیکھیں، یا ایک منٹ انتظار کر کے دوبارہ بھیجیں۔',
      resend: 'لنک دوبارہ بھیجیں',
      sent: 'ہم نے نیا لنک بھیج دیا ہے۔',
      back: 'سائن اِن پر واپس جائیں',
    },
    forgot: {
      title: 'اپنا پاس ورڈ ری سیٹ کریں',
      description: 'اپنے اکاؤنٹ کا ای میل پتہ درج کریں۔ ہم نیا پاس ورڈ چننے کا لنک بھیجیں گے۔',
      submit: 'ری سیٹ لنک بھیجیں',
    },
    reset: {
      title: 'نیا پاس ورڈ چنیں',
      description: 'پاس ورڈ بدلنے پر آپ اپنے دوسرے سیشنز سے سائن آؤٹ ہو جائیں گے۔',
      password: 'نیا پاس ورڈ',
      submit: 'نیا پاس ورڈ محفوظ کریں',
      invalidLink: 'یہ ری سیٹ لنک غلط ہے یا اس کی مدت ختم ہو چکی ہے۔ نیا لنک مانگیں۔',
      requestNew: 'نیا لنک مانگیں',
      done: 'آپ کا پاس ورڈ تبدیل ہو گیا۔ نئے پاس ورڈ سے سائن اِن کریں۔',
    },
    reauth: {
      stepUpTitle: 'تصدیق کریں کہ یہ آپ ہی ہیں',
      stepUpDescription:
        'اس کام کے لیے حال ہی میں سائن اِن ہونا ضروری ہے۔ جاری رکھنے کے لیے اپنا پاس ورڈ درج کریں۔ اس صفحے پر آپ کا کام برقرار رہے گا۔',
      expiredTitle: 'جاری رکھنے کے لیے سائن اِن کریں',
      expiredDescription:
        'آپ کا سیشن ختم ہو گیا۔ جاری رکھنے کے لیے دوبارہ سائن اِن کریں۔ تب تک اس صفحے پر غیر محفوظ تبدیلیاں برقرار رہیں گی۔',
      account: 'اکاؤنٹ',
      confirm: 'تصدیق کریں',
      signInAgain: 'دوبارہ سائن اِن کریں',
      otherAccount: 'کسی اور اکاؤنٹ سے سائن اِن کریں',
      masked: 'سائن اِن کرنے تک ورک اسپیس کا مواد چھپا رہے گا۔',
    },
  },
  tenants: {
    title: 'ورک اسپیس چنیں',
    description:
      'ورک اسپیسز برانڈز، لوگوں اور گفتگو کو الگ الگ رکھتی ہیں۔ Studio اس براؤزر میں آپ کا انتخاب یاد رکھتا ہے۔',
    yours: 'آپ کی ورک اسپیسز',
    open: 'کھولیں',
    current: 'موجودہ',
    unavailable: 'آپ ابھی یہ ورک اسپیس نہیں کھول سکتے۔',
    status: {
      active: 'فعال',
      suspended: 'معطل',
      closing: 'بند ہو رہی ہے',
      invited: 'دعوت زیرِ التوا',
      removed: 'ہٹا دی گئی',
    },
    empty: {
      title: 'ابھی کوئی ورک اسپیس نہیں',
      description: 'شروع کرنے کے لیے ایک بنائیں، یا کسی ساتھی سے آپ کو مدعو کرنے کو کہیں۔',
    },
    create: {
      title: 'ورک اسپیس بنائیں',
      name: 'ورک اسپیس کا نام',
      nameHint: 'عام طور پر آپ کی کمپنی یا ٹیم کا نام۔',
      slug: 'ورک اسپیس کا پتہ',
      slugHint: '3 سے 40 چھوٹے انگریزی حروف، ہندسے یا ہائفن۔ لنکس میں استعمال ہوتا ہے۔',
      language: 'طے شدہ زبان',
      submit: 'ورک اسپیس بنائیں',
      nameRequired: 'ورک اسپیس کا نام درج کریں۔',
      slugInvalid:
        '3 سے 40 چھوٹے انگریزی حروف، ہندسے یا ہائفن استعمال کریں، جو کسی حرف یا ہندسے سے شروع اور ختم ہوں۔',
      slugTaken: 'یہ پتہ پہلے سے لیا جا چکا ہے۔ کوئی اور آزمائیں۔',
      created: 'ورک اسپیس بن گئی۔',
    },
    revoked: {
      title: 'اس ورک اسپیس تک آپ کی رسائی بدل گئی ہے',
      description: 'آپ اب {{name}} نہیں کھول سکتے۔ اس کا ڈیٹا اس ٹیب سے ہٹا دیا گیا ہے۔',
    },
  },
  shell: {
    aiStopped: 'AI رکا ہوا ہے',
    stopAi: 'AI روکیں',
    stopAiLabel: 'AI کے جوابات روکیں',
    killBanner: {
      title: 'AI کے جوابات رکے ہوئے ہیں',
      people: 'لوگ بات چیت جاری رکھتے ہیں۔ نئے پیغامات آپ کی ٹیم کو جاتے ہیں۔',
      review: 'رکاوٹیں دیکھیں',
    },
    scope: {
      tenant: 'اس ورک اسپیس میں ہر جگہ',
      brand: 'برانڈ: {{name}}',
      agent: 'ایجنٹ: {{name}}',
    },
    reason: 'وجہ: {{reason}}',
    since: '{{time}} سے',
  },
  overview: {
    degraded: {
      title: 'ہوم کا ایک حصہ لوڈ نہیں ہو سکا',
      description:
        'Studio کا باقی حصہ کام کر رہا ہے، آپ کا ان باکس بھی۔ نیچے ہر حصے کو الگ سے دوبارہ آزمایا جا سکتا ہے۔',
    },
    title: 'جائزہ',
    greeting: 'خوش آمدید، {{name}}۔',
    chats: {
      title: 'آپ کی چیٹس',
      description: 'وہ کسٹمرز جو کسی شخص کے منتظر ہیں، اور آپ کو سونپی گئی چیٹس۔',
      loading: 'آپ کی چیٹس لوڈ ہو رہی ہیں',
      waiting: 'کسی شخص کا انتظار',
      mine: 'آپ کو سونپی گئی',
      caughtUp: 'اس وقت آپ کے لیے کچھ انتظار میں نہیں ہے۔',
      open: 'ان باکس کھولیں',
    },
    setup: {
      title: 'سیٹ اپ مکمل کریں',
      description: 'کسٹمرز آپ کے AI معاون سے چیٹ کر سکیں، اس سے پہلے یہ مراحل باقی ہیں۔',
      steps: {
        engine: {
          title: 'چیٹ انجن جوڑیں',
          description: 'ایک برانڈ کو جوڑیں تاکہ اس کی چیٹس آپ کی ٹیم تک پہنچیں۔',
        },
        brand: {
          title: 'برانڈ شامل کریں اور چیٹ انسٹال کریں',
          description: 'اسے نام دیں، اپنی ویب سائٹ کو اجازت دیں اور اس میں انسٹال کوڈ شامل کریں۔',
        },
        agent: {
          title: 'AI ایجنٹ شائع کریں',
          description: 'آپ کا معاون کسٹمرز کو تب ہی جواب دیتا ہے جب آپ اسے شائع کریں۔',
        },
        team: {
          title: 'ساتھی کو مدعو کریں',
          description: 'ان لوگوں کو شامل کریں جو آپ کے ساتھ چیٹس کا جواب دیں گے۔',
        },
      },
    },
    brands: {
      title: 'برانڈز',
      description: 'ہر برانڈ کے لیے چیٹ کنکشن اور AI کی صورتحال۔',
      loading: 'برانڈز لوڈ ہو رہے ہیں',
      columns: { chat: 'چیٹ کنکشن', ai: 'AI معاون' },
      install: 'انسٹال',
      openAgent: 'ایجنٹ کھولیں',
      empty: {
        title: 'ابھی کوئی برانڈ نہیں',
        description: 'ہر برانڈ کا اپنا چیٹ وجیٹ، اجازت یافتہ ویب سائٹس اور AI معاون ہوتا ہے۔',
        action: 'برانڈ بنائیں',
      },
    },
    stops: {
      title: 'AI روکنے کے سوئچ',
      none: 'AI کہیں بھی رکا ہوا نہیں ہے۔',
      loading: 'روکنے کے سوئچ لوڈ ہو رہے ہیں',
      manage: 'رکاوٹوں کا انتظام کریں',
    },
    runs: {
      title: 'تازہ ترین رنز',
      description: 'AI نے حال ہی میں کیا کیا۔ یہاں کسی پیغام کا متن نہیں رکھا جاتا۔',
      loading: 'رنز لوڈ ہو رہے ہیں',
      viewAll: 'تمام رنز دیکھیں',
      empty: {
        title: 'ابھی کوئی رن نہیں',
        description: 'جب AI کسی گفتگو میں جواب دیتا ہے یا ڈرافٹ لکھتا ہے تو رنز نظر آتے ہیں۔',
      },
    },
  },
  status: {
    connection: {
      active: 'منسلک',
      provisioning: 'سیٹ اپ ہو رہا ہے',
      degraded: 'توجہ درکار',
      disabled: 'غیر فعال',
      none: 'منسلک نہیں',
    },
    agent: {
      live: 'لائیو · v{{version}}',
      draftOnly: 'صرف ڈرافٹ',
      draftAhead: 'ڈرافٹ v{{version}} لائیو نہیں',
      archived: 'آرکائیو شدہ',
      none: 'کوئی ایجنٹ نہیں',
    },
  },
  brands: {
    title: 'برانڈز اور انسٹال',
    description: 'ایک برانڈ بنائیں، اسے Chatwoot سے جوڑیں اور اپنی ویب سائٹ پر چیٹ شامل کریں۔',
    loading: 'برانڈز لوڈ ہو رہے ہیں',
    create: 'برانڈ بنائیں',
    createTitle: 'برانڈ بنائیں',
    name: 'برانڈ کا نام',
    nameHint: 'گاہک اسے چیٹ میں دیکھتے ہیں۔',
    nameRequired: 'برانڈ کا نام درج کریں۔',
    websites: 'اجازت یافتہ ویب سائٹس',
    websitesHint:
      'ہر سطر میں ایک، جیسے https://shop.example.com۔ صرف یہی ویب سائٹس چیٹ لوڈ کر سکتی ہیں۔',
    websiteInvalid:
      '{{value}} ویب سائٹ کا پتہ نہیں ہے۔ https://shop.example.com جیسی شکل استعمال کریں، بغیر پاتھ کے۔',
    area: 'ورک اسپیس کا حصہ',
    submit: 'برانڈ بنائیں',
    created: '{{name}} بن گیا۔',
    widgetId: 'وجیٹ ID',
    allowed: 'اجازت یافتہ ویب سائٹس',
    noWebsites: 'ابھی کسی ویب سائٹ کی اجازت نہیں، اس لیے چیٹ کہیں لوڈ نہیں ہو گی۔',
    edit: 'ترمیم',
    editLabel: '{{name}} میں ترمیم کریں',
    editTitle: '{{name}} میں ترمیم',
    save: 'تبدیلیاں محفوظ کریں',
    saved: '{{name}} محفوظ ہو گیا۔',
    removedWarning:
      'محفوظ کرتے ہی فہرست سے ہٹائی گئی ویب سائٹس پر کھلی چیٹس ختم ہو جائیں گی، اور وہاں چیٹ لوڈ نہیں ہوگی:',
    empty: {
      title: 'ابھی کوئی برانڈ نہیں',
      description: 'ہر برانڈ کا اپنا چیٹ وجیٹ، اجازت یافتہ ویب سائٹس اور AI معاون ہوتا ہے۔',
    },
    chat: {
      title: 'چیٹ کنکشن',
      account: 'Chatwoot اکاؤنٹ {{id}}',
      connect: 'Chatwoot سے جوڑیں',
      connectTitle: '{{name}} کو Chatwoot سے جوڑیں',
      engineNote:
        'Hamnivo، Chatwoot کو اپنے چیٹ انجن کے طور پر استعمال کرتا ہے۔ آپ اور آپ کی ٹیم Hamnivo Studio میں کام کرتے ہیں؛ آپ کو Chatwoot کھولنے کی ضرورت نہیں۔',
      connectIntro: 'Hamnivo اس برانڈ کے لیے ایک Chatwoot اکاؤنٹ سیٹ اپ کرتا ہے جس میں یہ ہوں گے:',
      connectItem1: 'ایک انٹیگریشن صارف اور ویب سائٹ چیٹ کے لیے ایک ان باکس،',
      connectItem2: 'ایک AI بوٹ جو اس ان باکس میں جواب دیتا ہے،',
      connectItem3: 'Hamnivo کو واپس دستخط شدہ ویب ہُکس۔',
      connectNote:
        'برانڈ کا AI معاون ڈرافٹ کے طور پر بنتا ہے۔ جب تک آپ اسے شائع نہ کریں، یہ گاہکوں کو جواب نہیں دیتا۔',
      connectSubmit: 'جوڑیں',
      connected: '{{name}} Chatwoot سے منسلک ہو گیا ہے۔',
      noPermission: 'Chatwoot جوڑنے کے لیے آپ کو انٹیگریشنز کے انتظام کی اجازت درکار ہے۔',
      statusHidden:
        'یہ صورتحال صرف وہ لوگ دیکھتے ہیں جو پوری ورک اسپیس کی انٹیگریشنز کا انتظام کرتے ہیں۔',
    },
    install: {
      title: 'چیٹ انسٹال کریں',
      description:
        'یہ کوڈ اجازت یافتہ ویب سائٹ کے ہر صفحے پر، بند ہونے والے </body> ٹیگ سے ذرا پہلے شامل کریں۔',
      copy: 'انسٹال کوڈ کاپی کریں',
      copied: 'انسٹال کوڈ کاپی ہو گیا۔',
      copyFailed: 'کاپی نہیں ہو سکا۔ کوڈ منتخب کر کے خود کاپی کریں۔',
      note: 'صرف کوڈ کاپی کرنے سے کچھ منسلک نہیں ہوتا۔ اجازت یافتہ ویب سائٹ پر کوڈ چلنے کے بعد چیٹ نظر آتی ہے۔',
    },
  },
  agents: {
    title: 'AI ایجنٹس',
    description:
      'ہر ایجنٹ ایک برانڈ کے لیے جواب دیتا ہے۔ تبدیلیاں ڈرافٹ کے طور پر محفوظ ہوتی ہیں اور صرف شائع کرنے پر لائیو ہوتی ہیں۔',
    loading: 'ایجنٹس لوڈ ہو رہے ہیں',
    columns: {
      answers: 'کہاں جواب دیتا ہے',
      name: 'ایجنٹ',
      brand: 'برانڈ',
      model: 'ماڈل',
      live: 'لائیو ورژن',
    },
    isDefault: 'برانڈ کا طے شدہ',
    draft: 'v{{version}}',
    notPublished: 'شائع نہیں ہوا',
    open: '{{name}} کھولیں',
    create: 'ایجنٹ بنائیں',
    empty: {
      title: 'ابھی کوئی AI ایجنٹ نہیں',
      description:
        'کسی برانڈ کو Chatwoot سے جوڑنے پر اس کا معاون ڈرافٹ کے طور پر بنتا ہے۔ آپ یہاں بھی ایجنٹ بنا سکتے ہیں۔',
    },
    draftModel: 'مسودہ: {{model}}',
    noPurpose: 'ابھی کوئی مقصد نہیں لکھا گیا۔',
    answers: {
      customers:
        '{{brand}} کے صارفین کو ویب چیٹ میں اور برانڈ کے ان چینلز پر جواب دیتا ہے جہاں AI آن ہے۔',
      assist: '{{brand}} کی چیٹس پر آپ کی ٹیم کو جوابات تجویز کرتا ہے۔ صارفین کو کبھی نہیں لکھتا۔',
      notDefault:
        'کسی کو جواب نہیں دیتا: صرف {{brand}} کا ڈیفالٹ ایجنٹ جواب دیتا ہے۔ استعمال کے لیے اسے ڈیفالٹ بنائیں۔',
      notLive: 'ابھی کسی کو جواب نہیں دیتا: یہ شائع نہیں ہوا۔',
      archived: 'محفوظ شدہ۔ کسی کو جواب نہیں دیتا۔',
    },
    filters: {
      search: 'ایجنٹ تلاش کریں',
      searchHint: 'نام، دکھائے جانے والے نام، مقصد، برانڈ یا ماڈل سے۔',
      brand: 'برانڈ',
      allBrands: 'تمام برانڈز',
      state: 'دکھائیں',
      all: 'تمام ایجنٹ',
      answering: 'ابھی جواب دے رہے ہیں',
      idle: 'جواب نہیں دے رہے',
      count: '{{total}} میں سے {{shown}} ایجنٹ دکھائے جا رہے ہیں۔',
      none: 'ان فلٹرز سے کوئی ایجنٹ نہیں ملتا۔',
      clear: 'فلٹرز صاف کریں',
    },
    createForm: {
      title: 'ایجنٹ بنائیں',
      brand: 'برانڈ',
      name: 'اندرونی نام',
      nameHint: 'یہ نام صرف عملہ دیکھتا ہے۔',
      nameRequired: 'اندرونی نام درج کریں۔',
      brandRequired: 'برانڈ چنیں۔',
      makeDefault: 'اسے برانڈ کا طے شدہ ایجنٹ بنائیں',
      makeDefaultHint: 'طے شدہ ایجنٹ برانڈ کی گفتگو میں جواب دیتا ہے۔',
      submit: 'ایجنٹ بنائیں',
      created: '{{name}} ڈرافٹ کے طور پر بن گیا۔',
      noBrands: 'پہلے ایک برانڈ بنائیں۔',
    },
  },
  editor: {
    loading: 'ایجنٹ لوڈ ہو رہا ہے',
    allAgents: 'تمام ایجنٹس',
    brand: 'برانڈ: {{name}}',
    notLive: {
      title: 'محفوظ شدہ لائیو نہیں ہے',
      live: 'جب تک آپ شائع نہیں کرتے، گاہکوں کو ورژن {{version}} ملتا رہے گا۔',
      none: 'جب تک آپ کوئی ورژن شائع نہیں کرتے، یہ ایجنٹ گاہکوں کو جواب نہیں دیتا۔',
      draftAhead: 'ڈرافٹ ورژن {{version}} میں ایسی تبدیلیاں ہیں جو ابھی لائیو نہیں۔',
    },
    unsaved: 'غیر محفوظ تبدیلیاں',
    allSaved: 'تمام تبدیلیاں محفوظ ہیں',
    readOnly: 'آپ یہ ایجنٹ دیکھ سکتے ہیں لیکن تبدیل نہیں کر سکتے۔',
    sections: {
      identity: 'شناخت',
      behaviour: 'رویہ',
      model: 'ماڈل',
      limits: 'حدود',
      knowledge: 'معلومات',
      memory: 'کسٹمر میموری',
    },
    displayName: 'گاہکوں کو نظر آنے والا نام',
    displayNameHint:
      'ہر AI پیغام کے ساتھ دکھایا جاتا ہے۔ کردار بیان کریں، جیسے “اسٹور معاون”۔ کسی شخص کا نام استعمال نہ کریں۔',
    purpose: 'مقصد',
    purposeHint: 'یہ ایجنٹ کس لیے ہے، ایک دو جملوں میں۔',
    instructions: 'ہدایات',
    instructionsHint:
      'آپ کے کاروبار کے اصول اور انداز۔ Hamnivo دیانت اور حفاظت کے اصول شامل کرتا ہے جنہیں ہٹایا نہیں جا سکتا۔',
    tone: 'لہجہ',
    tones: {
      warm: 'گرم جوش',
      warmHint: 'دوستانہ اور بات چیت والا۔',
      neutral: 'غیر جانب دار',
      neutralHint: 'سادہ اور سیدھا۔',
      formal: 'رسمی',
      formalHint: 'مہذب اور درست۔',
    },
    languages: 'جواب کی زبانیں',
    languagesHint: 'کسی دوسری زبان میں لکھنے والے گاہک کو کسی شخص سے بات کرنے کی پیشکش کی جاتی ہے۔',
    otherLanguages: 'دیگر زبانوں کے ٹیگ',
    otherLanguagesHint: 'اختیاری۔ کوما سے الگ کریں، جیسے hi-Latn, ur-Latn۔',
    mode: 'موڈ',
    modes: {
      answer: 'گاہکوں کو جواب دیں',
      answerHint: 'چیٹ میں جواب دیتا ہے۔',
      assist: 'عملے کی مدد کریں',
      assistHint:
        'آپ کی ٹیم کے لیے جواب کا مسودہ لکھتا ہے، جسے وہ منظور کریں، ترمیم کریں یا مسترد کریں۔ گاہکوں کو خود کبھی جواب نہیں دیتا۔',
    },
    provider: 'فراہم کنندہ',
    providers: {
      anthropic: 'Anthropic',
      openai: 'OpenAI',
      google: 'Google Gemini',
      'openai-compatible': 'OpenAI سے مطابقت رکھنے والا سرور',
      mock: 'Hamnivo ٹیسٹ ماڈل (آف لائن)',
    },
    modelId: 'ماڈل ID',
    modelIdHint: 'بالکل ویسے جیسے فراہم کنندہ اسے نام دیتا ہے۔',
    credentials: 'اسناد',
    platformKey: 'سرور کی کلید (Hamnivo شروع ہونے پر سیٹ ہوتی ہے)',
    credentialsHint:
      'محفوظ کیا ہوا ماڈل کنکشن استعمال کریں، یا وہ کلید جس کے ساتھ سرور شروع کیا گیا تھا۔',
    connectionsHidden: 'آپ ماڈل کنکشنز نہیں دیکھ سکتے، اس لیے موجودہ انتخاب برقرار رہتا ہے۔',
    unknownConnection: 'محفوظ شدہ کنکشن {{id}}',
    fallback: 'متبادل ماڈلز',
    fallbackHint:
      'جب مرکزی ماڈل پر زیادہ بوجھ ہو یا وہ دستیاب نہ ہو تو ترتیب سے آزمائے جاتے ہیں۔ زیادہ سے زیادہ 2۔',
    fallbackItem: 'متبادل {{n}}',
    addFallback: 'متبادل ماڈل شامل کریں',
    removeFallback: 'متبادل {{n}} ہٹائیں',
    limits: {
      hint: 'جب کوئی رن کسی حد تک پہنچتا ہے تو وہ رک جاتا ہے اور گفتگو کسی شخص کے حوالے کر دیتا ہے۔',
      maxOutputTokens: 'سب سے لمبا جواب (ٹوکنز)',
      timeout: 'وقت کی حد (سیکنڈ)',
      historyMessages: 'پڑھے جانے والے پچھلے پیغامات',
      maxSteps: 'ایک رن میں زیادہ سے زیادہ مراحل',
    },
    knowledge: {
      hint: 'گاہکوں کے جوابات صرف عوامی ذرائع استعمال کرتے ہیں۔',
      none: 'اس برانڈ کے پاس ابھی معلومات کا کوئی ذریعہ نہیں۔',
      manage: 'معلومات کا انتظام کریں',
      hidden: 'آپ معلومات کے ذرائع نہیں دیکھ سکتے۔',
    },
    memory: {
      enabled: 'کسٹمرز کی پسند یاد رکھیں',
      hint: 'صرف ان کسٹمرز کے لیے جو چیٹ میں رضامندی دیں۔ وہ دیکھ سکتے ہیں کہ کیا یاد رکھا گیا ہے، اسے درست کر سکتے ہیں، حذف کر سکتے ہیں اور میموری بند کر سکتے ہیں۔',
      maxItems: 'ایک جواب میں زیادہ سے زیادہ یادیں',
      maxChars: 'ایک جواب میں میموری کے زیادہ سے زیادہ حروف',
    },
    save: 'ڈرافٹ محفوظ کریں',
    saved: 'ڈرافٹ ورژن {{version}} کے طور پر محفوظ ہو گیا۔',
    discard: 'تبدیلیاں ترک کریں',
    publish: 'ورژن {{version}} شائع کریں',
    publishNone: 'شائع کریں',
    publishWhy: {
      unsaved: 'شائع کرنے سے پہلے ڈرافٹ محفوظ کریں۔',
      noDraft: 'شائع کرنے کے لیے کوئی نیا ڈرافٹ نہیں ہے۔',
      noPermission: 'ایجنٹس شائع کرنے کے لیے آپ کو اجازت درکار ہے۔',
      archived: 'آرکائیو شدہ ایجنٹس شائع نہیں کیے جا سکتے۔',
    },
    publishConfirm: {
      title: 'ورژن {{version}} شائع کریں؟',
      body: 'گاہکوں کو فوراً ورژن {{version}} سے جوابات ملنے لگیں گے۔',
      replaces: 'ورژن {{version}} جواب دینا بند کر دے گا۔',
      first: 'یہ پہلا ورژن ہے جو گاہک دیکھیں گے۔',
      submit: 'شائع کریں',
    },
    published: 'ورژن {{version}} لائیو ہے۔',
    publishFailed: 'ورژن {{version}} شائع نہیں ہوا۔ لائیو ورژن تبدیل نہیں ہوا۔',
    conflict: {
      title: 'کسی نے نیا ڈرافٹ محفوظ کیا ہے',
      body: 'آپ کے ترمیم کرتے وقت ورژن {{version}} محفوظ ہوا۔ آپ کی تبدیلیاں ابھی یہیں ہیں۔',
      differences: 'نئے ڈرافٹ سے مختلف فیلڈز:',
      same: 'نئے ڈرافٹ میں وہی قدریں ہیں جو آپ کے پاس ہیں۔',
      loadTheirs: 'نیا ڈرافٹ لوڈ کریں',
      keepMine: 'میری تبدیلیاں رکھیں',
      keepMineHint: 'آپ کا ورژن نئے ڈرافٹ کے اوپر محفوظ کرتا ہے۔',
    },
    versions: {
      title: 'ورژنز',
      loading: 'ورژنز لوڈ ہو رہے ہیں',
      state: { draft: 'ڈرافٹ', published: 'لائیو', retired: 'سابقہ' },
      version: 'ورژن {{version}}',
      hash: 'ہیش',
      noHash: 'شائع ہونے پر طے ہوتا ہے',
      created: 'بنایا گیا: {{time}}',
      publishedAt: 'شائع ہوا: {{time}}',
      rollback: 'ورژن {{version}} پر واپس جائیں',
      rollbackTitle: 'ورژن {{version}} پر واپس جائیں؟',
      rollbackBody:
        'ورژن {{version}} دوبارہ لائیو ہو جائے گا۔ آپ کا ڈرافٹ برقرار رہے گا اور بعد میں شائع کیا جا سکتا ہے۔',
      rollbackSubmit: 'واپس جائیں',
      rolledBack: 'ورژن {{version}} دوبارہ لائیو ہے۔',
      empty: 'ابھی کوئی ورژن نہیں۔',
    },
    leave: {
      title: 'محفوظ کیے بغیر چھوڑیں؟',
      description: 'اس ایجنٹ میں آپ کی تبدیلیاں محفوظ نہیں ہوئیں۔',
      save: 'ڈرافٹ محفوظ کریں',
      discard: 'ترک کریں',
      stay: 'یہیں رہیں',
    },
    errors: {
      summary: 'محفوظ کرنے کے لیے یہ فیلڈز درست کریں',
      displayName: 'گاہکوں کو نظر آنے والا نام درج کریں، 60 حروف تک۔',
      purpose: 'مقصد 2,000 حروف سے کم رکھیں۔',
      instructions: 'ہدایات 20,000 حروف سے کم رکھیں۔',
      languages: 'کم از کم ایک زبان چنیں، اور 20 سے زیادہ نہیں۔',
      languageTag: '{{tag}} زبان کا ٹیگ نہیں ہے۔ hi-Latn جیسی شکل استعمال کریں۔',
      modelId: 'ماڈل ID درج کریں۔',
      number: '{{min}} سے {{max}} تک کوئی مکمل عدد درج کریں۔',
      knowledge: '20 سے زیادہ ذرائع نہ چنیں۔',
    },
  },
  models: {
    title: 'ماڈل کنکشنز',
    description:
      'ماڈل فراہم کنندگان کی API کلیدیں۔ کلیدیں خفیہ کر کے محفوظ کی جاتی ہیں اور محفوظ کرنے کے بعد دوبارہ کبھی نہیں دکھائی جاتیں۔',
    loading: 'ماڈل کنکشنز لوڈ ہو رہے ہیں',
    add: 'کنکشن شامل کریں',
    addTitle: 'ماڈل کنکشن شامل کریں',
    provider: 'فراہم کنندہ',
    label: 'لیبل',
    labelHint: 'آپ اور آپ کی ٹیم کے لیے، جیسے “OpenAI پروڈکشن”۔',
    baseUrl: 'بنیادی URL',
    baseUrlHint:
      'OpenAI سے مطابقت رکھنے والے سرورز کے لیے ضروری۔ دوسروں کے لیے اختیاری (پراکسی یا علاقہ)۔',
    apiKey: 'API کلید',
    apiKeyHint: 'خفیہ کر کے محفوظ کی جاتی ہے۔ آپ اسے دوبارہ نہیں دیکھیں گے، صرف اس کے آخری حروف۔',
    allowedModels: 'اجازت یافتہ ماڈلز',
    allowedModelsHint: 'اختیاری۔ ہر سطر میں ایک ماڈل ID۔ کسی بھی ماڈل کی اجازت کے لیے خالی چھوڑیں۔',
    submit: 'کنکشن محفوظ کریں',
    added:
      'کنکشن محفوظ ہو گیا۔ کلید خفیہ کر کے محفوظ کی گئی ہے اور دوبارہ نہیں دکھائی جائے گی۔ اس کے آخری حروف {{hint}} ہیں۔',
    columns: {
      label: 'لیبل',
      provider: 'فراہم کنندہ',
      key: 'کلید',
      models: 'اجازت یافتہ ماڈلز',
      status: 'صورتحال',
      created: 'شامل کیا گیا',
      actions: 'اقدامات',
    },
    anyModel: 'کوئی بھی ماڈل',
    keyEnding: 'آخری حروف {{hint}}',
    status: { active: 'فعال', disabled: 'غیر فعال' },
    disable: 'غیر فعال کریں',
    disableLabel: '{{label}} غیر فعال کریں',
    disableTitle: '{{label}} غیر فعال کریں؟',
    disableBody:
      'اسے استعمال کرنے والے ایجنٹس تب تک جواب نہیں دیں گے جب تک آپ دوسری اسناد نہ چنیں۔ محفوظ کلید منسوخ ہو جاتی ہے اور واپس نہیں مل سکتی۔',
    disableSubmit: 'کنکشن غیر فعال کریں',
    disabled: '{{label}} غیر فعال ہے۔',
    empty: {
      title: 'ابھی کوئی ماڈل کنکشن نہیں',
      description:
        'اس کے بغیر ایجنٹس صرف وہی فراہم کنندگان استعمال کر سکتے ہیں جن کی کلیدیں سرور کے پاس ہیں، اور آف لائن ٹیسٹ ماڈل۔',
    },
    errors: {
      label: 'لیبل درج کریں۔',
      apiKey: 'API کلید درج کریں۔ اس میں کم از کم 8 حروف ہوتے ہیں۔',
      baseUrl: 'http:// یا https:// سے شروع ہونے والا پتہ درج کریں۔',
      baseUrlRequired: 'OpenAI سے مطابقت رکھنے والے سرورز کو بنیادی URL درکار ہے۔',
    },
  },
  knowledge: {
    title: 'معلومات',
    description:
      'وہ ذرائع جن سے AI جواب دیتا ہے۔ جوابات میں استعمال سے پہلے دستاویزات کی جانچ اور انڈیکسنگ ہوتی ہے۔',
    sources: {
      title: 'ذرائع',
      loading: 'ذرائع لوڈ ہو رہے ہیں',
      add: 'ذریعہ شامل کریں',
      documents: 'دستاویزات: {{total}}',
      review: 'ہر {{days}} دن میں جائزہ',
      noReview: 'کوئی جائزہ چکر نہیں',
      settings: '{{name}} کی ترتیبات',
      empty: {
        title: 'اپنا پہلا قابلِ اعتماد ذریعہ شامل کریں',
        description: 'اپنے پاس پہلے سے موجود مواد سے AI کو درست معلومات دیں۔',
      },
    },
    visibility: {
      public: 'عوامی جوابات',
      internal: 'صرف ٹیم',
      publicHint: 'گاہکوں کے جوابات کی بنیاد بن سکتا ہے۔',
      internalHint:
        'صرف آپ کی ٹیم کے لیے، جیسے معلومات کی تلاش میں۔ گاہکوں کے جوابات یا مسودوں میں کبھی استعمال نہیں ہوتا۔',
    },
    sourceStatus: { active: 'فعال', paused: 'موقوف', retired: 'استعمال بند' },
    sourceForm: {
      addTitle: 'معلومات کا ذریعہ شامل کریں',
      editTitle: 'ذریعے کی ترتیبات',
      brand: 'برانڈ',
      name: 'ذریعے کا نام',
      nameRequired: 'ذریعے کا نام درج کریں۔',
      visibility: 'اس سے ملنے والے جوابات کون دیکھ سکتا ہے',
      review: 'جائزے کا چکر (دنوں میں)',
      reviewHint:
        'اختیاری۔ جن دستاویزات کا اتنے دنوں میں جائزہ نہ ہو، وہ تب تک جوابات کی بنیاد نہیں بنتیں جب تک کوئی ان کا جائزہ نہ لے۔',
      reviewInvalid: '1 سے 3650 تک دنوں کا مکمل عدد درج کریں، یا خالی چھوڑیں۔',
      status: 'صورتحال',
      submit: 'ذریعہ شامل کریں',
      save: 'ترتیبات محفوظ کریں',
      created: '{{name}} شامل ہو گیا۔',
      saved: 'ترتیبات محفوظ ہو گئیں۔',
    },
    documents: {
      title: 'دستاویزات',
      loading: 'دستاویزات لوڈ ہو رہی ہیں',
      add: 'دستاویز شامل کریں',
      pick: 'دستاویزات دیکھنے کے لیے کوئی ذریعہ چنیں۔',
      polling: 'جب دستاویزات پر کارروائی ہو رہی ہو، Studio ہر چند سیکنڈ میں اپ ڈیٹس چیک کرتا ہے۔',
      columns: {
        title: 'دستاویز',
        state: 'حالت',
        freshness: 'تازگی',
        version: 'ورژن',
      },
      select: '{{title}} کی تفصیلات دکھائیں',
      empty: {
        title: 'اس ذریعے میں ابھی کوئی دستاویز نہیں',
        description:
          'متن چسپاں کریں یا فائل اپ لوڈ کریں۔ جوابات میں استعمال سے پہلے اس کی جانچ اور انڈیکسنگ ہوتی ہے۔',
      },
    },
    state: {
      queued: 'قطار میں',
      processing: 'کارروائی جاری',
      ready: 'تیار',
      failed: 'ناکام',
      rejected: 'مسترد',
      superseded: 'تبدیل شدہ',
      retired: 'استعمال بند',
    },
    freshness: { current: 'تازہ', stale: 'جائزہ درکار', expired: 'مدت ختم' },
    detail: {
      title: 'دستاویز کی تفصیلات',
      back: 'دستاویزات پر واپس جائیں',
      answering: 'جواب دینے والا ورژن',
      newest: 'تازہ ترین ورژن',
      noneAnswering: 'ابھی کوئی ورژن جواب نہیں دیتا۔',
      version: 'ورژن {{version}}',
      size: 'سائز',
      passages: 'اقتباسات',
      added: 'شامل کیا گیا',
      readySince: 'کب سے تیار',
      validUntil: 'کب تک استعمال ہو گا',
      reviewed: 'آخری جائزہ',
      neverReviewed: 'ابھی جائزہ نہیں ہوا',
      reason: 'وجہ: {{reason}}',
      original: 'اصل کھولیں',
      keepsAnswering: 'نیا ورژن تیار ہونے تک ورژن {{version}} جواب دیتا رہے گا۔',
      markReviewed: 'جائزہ مکمل درج کریں',
      markedReviewed: '{{title}} کا جائزہ درج کر دیا گیا۔',
      retire: 'استعمال بند کریں',
      retireTitle: '{{title}} کا استعمال بند کریں؟',
      retireBody:
        'جوابات میں یہ دستاویز استعمال ہونا بند ہو جائے گی۔ یہ فہرست میں “استعمال بند” کے طور پر رہے گی۔',
      retireSubmit: 'دستاویز کا استعمال بند کریں',
      retired: '{{title}} کا استعمال بند کر دیا گیا۔',
      newVersion: 'نیا ورژن اپ لوڈ کریں',
    },
    upload: {
      addTitle: 'دستاویز شامل کریں',
      versionTitle: '{{title}} کا نیا ورژن',
      docTitle: 'عنوان',
      titleRequired: 'عنوان درج کریں۔',
      url: 'اصل پتہ (URL)',
      urlHint: 'اختیاری۔ حوالوں کے ساتھ دکھایا جاتا ہے تاکہ لوگ اصل پڑھ سکیں۔',
      urlInvalid: 'http:// یا https:// سے شروع ہونے والا پتہ درج کریں۔',
      language: 'زبان کا ٹیگ',
      languageHint: 'اختیاری، جیسے en، ar یا hi-Latn۔',
      languageInvalid: 'en یا hi-Latn جیسا زبان کا ٹیگ استعمال کریں۔',
      content: 'مواد',
      paste: 'متن چسپاں کریں',
      file: 'فائل اپ لوڈ کریں',
      format: 'فارمیٹ',
      formats: { markdown: 'Markdown', plain: 'سادہ متن', html: 'HTML' },
      text: 'متن',
      textRequired: 'متن چسپاں کریں۔',
      fileLabel: 'فائل',
      fileHint: 'PDF، Word (.docx)، HTML، Markdown یا سادہ متن، 5 MB تک۔',
      fileRequired: 'فائل چنیں۔',
      fileTooLarge: 'یہ فائل {{size}} کی ہے۔ فائل 5 MB تک ہو سکتی ہے۔',
      fileType:
        'اس قسم کی فائل معاون نہیں ہے۔ PDF، Word (.docx)، HTML، Markdown یا سادہ متن استعمال کریں۔',
      fileChosen: 'منتخب: {{name}}، {{size}}',
      validUntil: 'اس کے بعد استعمال بند کریں',
      validUntilHint: 'اختیاری، مثلاً کسی موسمی پالیسی کے لیے۔',
      submit: 'دستاویز شامل کریں',
      submitVersion: 'ورژن اپ لوڈ کریں',
      queued: '{{title}} جانچ کے لیے قطار میں ہے۔',
    },
    search: {
      title: 'تلاش کا پیش منظر',
      description: 'دیکھیں کہ کوئی جواب کون سے اقتباسات استعمال کرے گا۔',
      brand: 'برانڈ',
      audience: 'کس کے لیے جواب',
      audiences: {
        customer: 'گاہک (صرف عوامی ذرائع)',
        staff: 'عملہ (تمام ذرائع)',
      },
      query: 'سوال',
      queryRequired: 'سوال درج کریں۔',
      submit: 'تلاش کریں',
      results: 'اقتباسات، بہترین پہلے',
      found: 'ملنے والے اقتباسات: {{total}}',
      score: 'اسکور {{score}}',
      version: 'ورژن {{version}}',
      empty:
        'کوئی اقتباس مماثل نہیں۔ جواب مزید تفصیل مانگے گا یا کسی شخص سے بات کرنے کی پیشکش کرے گا۔',
      noBrands: 'اس کی معلومات تلاش کرنے کے لیے ایک برانڈ بنائیں۔',
    },
  },
  stopAi: {
    title: 'AI روکیں',
    description:
      'AI کے جوابات فوراً روکیں۔ لوگ بات چیت جاری رکھتے ہیں، اور نئے پیغامات آپ کی ٹیم کو جاتے ہیں۔',
    loading: 'روکنے کے سوئچ لوڈ ہو رہے ہیں',
    dialogTitle: 'AI کے جوابات روکیں',
    dialogDescription:
      'آپ جہاں چنیں، وہاں AI جواب دینا بند کر دیتا ہے۔ گفتگو آپ کی ٹیم کے لیے کھلی رہتی ہے۔',
    scope: 'کہاں روکنا ہے',
    scopes: {
      tenant: 'اس ورک اسپیس میں ہر جگہ',
      brand: 'ایک برانڈ',
      agent: 'ایک ایجنٹ',
    },
    brand: 'برانڈ',
    agent: 'ایجنٹ',
    choose: 'چنیں…',
    reason: 'وجہ',
    reasonHint: 'آپ کی ٹیم یہ دیکھتی ہے۔ مثال: “جوابات میں غلط قیمتیں”۔',
    submit: 'AI کے جوابات روکیں',
    stopped: 'AI کے جوابات روک دیے گئے۔ {{scope}}۔',
    errors: {
      reason: 'کم از کم 3 حروف کی وجہ بتائیں۔',
      target: 'چنیں کہ AI کہاں روکنا ہے۔',
    },
    active: { title: 'فعال رکاوٹیں', empty: 'AI کہیں بھی رکا ہوا نہیں ہے۔' },
    past: { title: 'پچھلی رکاوٹیں', empty: 'کوئی پچھلی رکاوٹ نہیں۔' },
    columns: {
      since: 'روکا گیا',
      by: 'کس نے',
      cleared: 'دوبارہ شروع',
    },
    status: { active: 'AI رکا ہوا ہے', cleared: 'دوبارہ شروع' },
    clear: 'AI کو دوبارہ جواب دینے دیں',
    clearLabel: 'AI کو دوبارہ جواب دینے دیں: {{scope}}',
    clearTitle: 'AI کو دوبارہ جواب دینے دیں؟',
    clearBody:
      'ان کے لیے AI کے جوابات دوبارہ شروع ہوں گے: {{scope}}۔ یقینی بنائیں کہ روکنے کی وجہ دور ہو گئی ہے۔',
    clearSubmit: 'AI کو جواب دینے دیں',
    cleared: 'AI کے جوابات دوبارہ شروع ہو گئے۔ {{scope}}۔',
    noPermission: 'AI روکنے یا دوبارہ شروع کرنے کے لیے آپ کو ایجنٹس شائع کرنے کی اجازت درکار ہے۔',
    you: 'آپ',
    teammate: 'ایک ساتھی',
    unknownTarget: 'نامعلوم ({{id}})',
  },
  runs: {
    title: 'رنز',
    description:
      'ہر AI رن نے کیا کیا: نتیجہ، ورژن، ماڈل، ٹوکنز اور وقت۔ پرامپٹس اور جوابات یہاں نہیں رکھے جاتے۔',
    loading: 'رنز لوڈ ہو رہے ہیں',
    filters: {
      label: 'رنز فلٹر کریں',
      agent: 'ایجنٹ',
      allAgents: 'تمام ایجنٹس',
      outcome: 'نتیجہ',
      allOutcomes: 'تمام نتائج',
      conversation: 'گفتگو کی ID',
      conversationHint: 'اختیاری، conv_ سے شروع ہوتی ہے',
      apply: 'فلٹرز لاگو کریں',
      reset: 'فلٹرز ری سیٹ کریں',
      outcomeNote: 'نتیجے کا فلٹر اس صفحے پر لوڈ شدہ رنز پر لاگو ہوتا ہے۔',
    },
    columns: {
      started: 'آغاز',
      outcome: 'نتیجہ',
      agent: 'ایجنٹ اور ورژن',
      model: 'ماڈل',
      tokens: 'ٹوکنز اندر / باہر',
      latency: 'لگنے والا وقت',
      details: 'تفصیلات',
    },
    outcome: {
      replied: 'جواب دیا',
      drafted: 'عملے کے لیے ڈرافٹ',
      handoff: 'کسی شخص کے حوالے',
      fenced: 'رد کیا گیا، گفتگو آگے بڑھ گئی',
      blocked: 'گارڈ نے روکا',
      error: 'خرابی',
      skipped: 'چھوڑ دیا گیا',
      cancelled: 'کسی شخص نے روکا',
      running: 'جاری',
    },
    view: 'دیکھیں',
    viewLabel: '{{time}} کو شروع ہونے والا رن دیکھیں',
    loadMore: 'مزید رنز لوڈ کریں',
    shown: 'دکھائے گئے رنز: {{total}}',
    empty: {
      title: 'ابھی کوئی رن نہیں',
      description: 'جب AI کسی گفتگو میں جواب دیتا ہے یا ڈرافٹ لکھتا ہے تو رنز نظر آتے ہیں۔',
      action: 'AI ایجنٹس کھولیں',
    },
    noMatches: {
      title: 'ان فلٹرز سے کوئی رن مماثل نہیں',
      description: 'مزید رنز دیکھنے کے لیے کوئی فلٹر ہٹائیں۔',
    },
    detail: {
      title: 'رن کی تفصیلات',
      loading: 'رن لوڈ ہو رہا ہے',
      summary: 'خلاصہ',
      states: {
        running: 'جاری',
        succeeded: 'کامیاب',
        failed: 'ناکام',
        skipped: 'چھوڑ دیا گیا',
      },
      kind: 'قسم',
      kinds: { reply: 'گاہک کو جواب', draft: 'عملے کے لیے ڈرافٹ', guard: 'پیغام گارڈ' },
      conversation: 'گفتگو',
      started: 'آغاز',
      finished: 'اختتام',
      errorKind: 'خرابی کی قسم',
      steps: 'مراحل',
      noSteps: 'کوئی مرحلہ درج نہیں ہوا۔',
      step: 'مرحلہ {{n}}',
      stepKinds: {
        model: 'ماڈل',
        guard: 'گارڈ',
        retrieval: 'معلومات کی تلاش',
        decision: 'فیصلہ',
        tool: 'ٹول',
      },
      stepStatus: { ok: 'ٹھیک', error: 'خرابی', blocked: 'روکا گیا', skipped: 'چھوڑ دیا گیا' },
      noDetail: 'مزید کوئی تفصیل نہیں۔',
      version: 'v{{version}}',
      noAgent: 'کوئی ایجنٹ نہیں',
    },
  },
  inbox: {
    title: 'ان باکس',
    documentTitle: '{{name}} · ان باکس',
    loading: 'گفتگوئیں لوڈ ہو رہی ہیں',
    conversationLoading: 'گفتگو لوڈ ہو رہی ہے',
    loadMore: 'مزید گفتگوئیں دکھائیں',
    shown: 'دکھائی گئی گفتگوئیں: {{n}}',
    unavailable: 'یہ گفتگو دستیاب نہیں',
    notFound: 'یہ کسی ایسے ورک اسپیس یا برانڈ میں ہو سکتی ہے جسے آپ نہیں دیکھ سکتے، یا لنک غلط ہے۔',
    back: 'ان باکس پر واپس جائیں',
    forbidden: {
      title: 'آپ یہاں گفتگوئیں نہیں دیکھ سکتے',
      description: 'ورک اسپیس کے مالک یا ایڈمن سے ایسا کردار مانگیں جس میں ان باکس شامل ہو۔',
    },
    queues: {
      label: 'قطاریں',
      mine: 'میری',
      unassigned: 'کسی شخص کا انتظار',
      overdue: 'تاخیر والی',
      ai: 'AI جواب دے رہا ہے',
      team: 'میری ٹیمیں',
      tickets: 'ٹکٹ',
      all: 'سب',
    },
    tickets: ticketsUr,
    sla: slaUr,
    aiDrafts: aiDraftsUr,
    offers: offersUr,
    blocking: blockingUr,
    keys: {
      plain: 'کلیدیں: حرکت کے لیے ↑ ↓ یا J K، کھولنے کے لیے Enter، واپسی کے لیے Esc۔',
      withSelect:
        'کلیدیں: حرکت کے لیے ↑ ↓ یا J K، کھولنے کے لیے Enter، منتخب کرنے کے لیے X، واپسی کے لیے Esc۔',
    },
    search: {
      label: 'گفتگوؤں اور پیغامات میں تلاش کریں',
      placeholder: 'نام، ای میل یا پیغام کا متن تلاش کریں',
      submit: 'تلاش کریں',
      loading: 'تلاش جاری ہے',
      tooShort: 'کم از کم 2 حروف لکھیں۔',
      found: 'گفتگوئیں: {{conversations}}۔ پیغامات: {{messages}}۔',
      conversations: 'صارفین',
      messages: 'پیغامات',
      none: 'کچھ نہیں ملا',
      noneHint: 'صرف وہی گفتگوئیں تلاش ہوتی ہیں جو آپ دیکھ سکتے ہیں۔',
      clear: 'تلاش صاف کریں',
      more: 'مزید پیغامات دکھائیں',
    },
    filters: {
      button: 'فلٹر',
      buttonCount: 'فلٹر ({{n}})',
      title: 'قطار فلٹر کریں',
      close: 'فلٹر بند کریں',
      status: 'حالت',
      statuses: {
        active: 'کھلی یا زیرِ التوا',
        snoozed: 'مؤخر شدہ',
        resolved: 'حل شدہ',
        all: 'کوئی بھی حالت',
      },
      brand: 'برانڈ',
      allBrands: 'تمام برانڈ',
      channel: 'چینل',
      allChannels: 'تمام چینل',
      language: 'صارف کی زبان',
      allLanguages: 'تمام زبانیں',
      tag: 'ٹیگ',
      allTags: 'تمام ٹیگ',
      active: 'فعال فلٹر: {{n}}',
      clear: 'فلٹر ہٹائیں',
    },
    empty: {
      filteredTitle: 'ان فلٹرز سے کوئی گفتگو میل نہیں کھاتی',
      filteredDescription: 'پوری قطار دیکھنے کے لیے فلٹر ہٹائیں۔',
      seeAll: 'تمام گفتگوئیں دیکھیں',
      overview: 'جائزے پر جائیں',
      mine: {
        title: 'آپ کو کچھ نہیں سونپا گیا',
        description: 'جو گفتگوئیں آپ سنبھالتے ہیں یا آپ کو دی جاتی ہیں، وہ یہاں نظر آتی ہیں۔',
      },
      unassigned: {
        title: 'کوئی کسی شخص کا انتظار نہیں کر رہا',
        description: 'جب کوئی صارف کسی شخص سے بات کرنا چاہے تو گفتگو یہاں انتظار کرتی ہے۔',
      },
      overdue: {
        title: 'کچھ بھی تاخیر میں نہیں',
        description:
          'جواب کے وقت کا ہدف پار کر چکی گفتگو یہاں نظر آتی ہیں، سب سے زیادہ تاخیر والی پہلے۔',
      },
      ai: {
        title: 'AI اس وقت کسی کو جواب نہیں دے رہا',
        description: 'جن گفتگوؤں کا جواب AI دے رہا ہے، وہ یہاں نظر آتی ہیں۔',
      },
      team: {
        title: 'آپ کی ٹیموں میں کچھ نہیں',
        description: 'آپ کی ٹیموں کو دی گئی گفتگوئیں یہاں نظر آتی ہیں۔',
      },
      tickets: {
        title: 'ابھی کوئی ٹکٹ نہیں',
        description:
          'جب جواب دینے کے لیے کوئی نہ ہو، تب رابطہ فارم سے چھوڑے گئے پیغامات ٹکٹ بن جاتے ہیں۔ وہ ہر گفتگو بھی، جسے آپ ٹکٹ بناتے ہیں۔',
      },
      all: {
        title: 'ابھی کوئی گفتگو نہیں',
        description: 'جب صارفین کسی جڑے ہوئے برانڈ سے لکھتے ہیں تو گفتگوئیں یہاں نظر آتی ہیں۔',
      },
    },
    pick: {
      title: 'ایک گفتگو منتخب کریں',
      description: 'پڑھنے اور جواب دینے کے لیے قطار سے ایک گفتگو کھولیں۔',
    },
    connection: {
      reconnecting:
        'دوبارہ جڑ رہے ہیں… اپڈیٹس میں دیر ہو سکتی ہے؛ ان باکس ہر 15 سیکنڈ میں جانچتا ہے۔ آپ کے مسودے محفوظ ہیں۔',
      offline: 'آپ آف لائن ہیں۔ واپسی تک آپ کے مسودے اسی براؤزر میں رہیں گے۔',
    },
    row: {
      noMessages: 'ابھی کوئی پیغام نہیں',
      team: 'ٹیم: {{name}}',
      from: { ai: 'AI:', staff: 'عملہ:', system: 'نوٹ:' },
    },
    owner: {
      ai: 'AI جواب دے رہا ہے',
      waiting: 'کسی شخص کا انتظار',
      waitingFor: 'انتظار: {{time}}',
      paused: 'AI رکا ہوا ہے',
      you: 'آپ',
      person: 'ایک شخص',
      external: 'Chatwoot میں کوئی شخص',
    },
    status: {
      open: 'کھلی',
      pending: 'زیرِ التوا',
      snoozed: 'مؤخر شدہ',
      snoozedUntil: '{{time}} تک مؤخر',
      resolved: 'حل شدہ',
      resolve: 'حل کریں',
      resolvedDone: 'گفتگو حل کر دی گئی۔',
      reopen: 'دوبارہ کھولیں',
      wake: 'مؤخری ختم کریں',
      reopened: 'گفتگو دوبارہ کھل گئی۔ اب آپ اسے سنبھال رہے ہیں۔',
    },
    identity: {
      verified: 'تصدیق شدہ صارف',
      anonymous: 'سائن اِن نہیں',
      unknown: 'نامعلوم صارف',
    },
    channel: {
      chat: 'ویب سائٹ چیٹ',
      email: 'ای میل',
      whatsapp: 'WhatsApp',
      telegram: 'Telegram',
      sms: 'SMS',
      other: 'دوسرا چینل',
    },
    details: {
      title: 'تفصیلات',
      show: 'تفصیلات',
      hide: 'تفصیلات چھپائیں',
    },
    banner: {
      ai: '{{name}} جواب دے رہا ہے۔ جواب دینے یا گفتگو سنبھالنے سے اس گفتگو میں AI رک جاتا ہے۔',
      other: '{{name}} یہ گفتگو سنبھال رہے ہیں۔',
      otherSince: '{{name}} یہ گفتگو سنبھال رہے ہیں۔ انہوں نے اسے {{time}} لیا۔',
      notesStill: 'آپ اب بھی اندرونی نوٹ شامل کر سکتے ہیں۔',
      asked: 'صارف نے کسی شخص سے بات کرنا چاہی۔',
      askedSince: 'صارف نے {{time}} کسی شخص سے بات کرنا چاہی۔',
      released: 'یہ گفتگو قطار میں واپس رکھی گئی۔',
      channelAiOff: 'اس چینل پر AI جواب نہیں دیتا، اس لیے کسی شخص کو جواب دینا ہوگا۔',
      waiting: 'یہ گفتگو کسی شخص کا انتظار کر رہی ہے۔',
      takeOver: 'گفتگو سنبھالیں',
      claim: 'مجھے سونپیں',
      claimLost: 'کسی اور نے یہ گفتگو پہلے لے لی۔ اب دکھ رہا ہے کہ اسے کون سنبھال رہا ہے۔',
    },
    presence: {
      viewing: '{{name}} دیکھ رہے ہیں',
      typingReply: '{{name}} جواب لکھ رہے ہیں',
      typingNote: '{{name}} نوٹ لکھ رہے ہیں',
      alsoReply: '{{name}} بھی یہاں جواب لکھ رہے ہیں۔',
      alsoNote: '{{name}} بھی یہاں نوٹ لکھ رہے ہیں۔',
    },
    assign: {
      button: 'سونپیں',
      me: 'مجھے سونپیں',
      colleagues: 'جواب دے سکنے والے ساتھی',
      current: 'ابھی ان کے پاس ہے',
      queue: 'قطار میں واپس',
      ai: 'AI کو واپس دیں',
      team: 'ٹیم',
      teamCurrent: 'ٹیم: {{name}}',
      noTeams: 'ابھی کوئی ٹیم نہیں',
      noTeam: 'کوئی ٹیم نہیں',
      doneMe: 'اب آپ یہ گفتگو سنبھال رہے ہیں۔',
      doneTo: '{{name}} کو سونپی گئی۔',
      doneQueue: 'قطار میں واپس رکھی گئی۔',
      doneAi: 'AI دوبارہ جواب دے رہا ہے۔',
      doneTeam: '{{name}} ٹیم کو سونپی گئی۔',
      doneNoTeam: 'ٹیم سے ہٹائی گئی۔',
    },
    transfer: {
      ask: 'گفتگو سنبھالنے کی درخواست کریں',
      title: 'گفتگو سنبھالنے کی درخواست کریں',
      description:
        '{{name}} کو ایک اندرونی نوٹ ملے گا جس میں یہ گفتگو آپ کو دینے کا کہا جائے گا۔ جب تک وہ یا کوئی سپروائزر ایسا نہ کرے، کچھ نہیں بدلتا۔',
      note: 'کیوں (آپ کے ساتھی کے لیے)',
      send: 'درخواست بھیجیں',
      sent: '{{name}} کو درخواست بھیج دی گئی۔',
    },
    snooze: {
      button: 'مؤخر کریں',
      hour: '1 گھنٹے کے لیے',
      tomorrow: 'کل تک ({{time}})',
      nextWeek: 'اگلے ہفتے تک ({{time}})',
      pick: 'وقت منتخب کریں…',
      pickTitle: 'کب تک مؤخر کریں',
      pickDescription: 'اس وقت، یا صارف کے لکھنے پر، گفتگو قطار میں واپس آ جاتی ہے۔',
      until: 'تاریخ اور وقت',
      future: 'مستقبل کا وقت منتخب کریں۔',
      confirm: 'مؤخر کریں',
      done: '{{time}} تک مؤخر کی گئی۔',
    },
    timeline: {
      label: 'پیغامات',
      loading: 'پیغامات لوڈ ہو رہے ہیں',
      older: 'پرانے پیغامات دکھائیں',
      empty: 'ابھی کوئی پیغام نہیں۔',
    },
    roles: {
      customer: 'صارف',
      staff: 'سپورٹ ایجنٹ',
      you: 'آپ',
      ai: 'AI معاون',
      specialist: 'AI ماہر',
      guest: 'مہمان',
      system: 'سسٹم',
    },
    lanes: {
      public: 'جواب',
      publicDescription: 'صارف جوابات دیکھتا ہے۔',
      internal: 'اندرونی نوٹ',
      internalDescription: 'نوٹ صرف آپ کی ٹیم دیکھتی ہے۔ صارف انہیں کبھی نہیں دیکھتا۔',
    },
    message: {
      handoffSummary: 'حوالگی کا خلاصہ',
      staffOnly: 'صرف عملے کے لیے',
      sources: 'ذرائع',
      newFrom: '{{name}} کا نیا پیغام۔',
      file: {
        quarantined: 'جانچ کا انتظار',
        scanning: 'جانچ جاری ہے',
        available: 'دستیاب',
        rejected: 'روک دی گئی',
      },
      place: 'ایک جگہ شیئر کی: {{label}}',
      contact: 'ایک رابطہ شیئر کیا: {{details}}',
      reaction: '{{emoji}} سے ردعمل دیا',
    },
    translation: {
      translate: '{{language}} میں ترجمہ کریں',
      label: '{{language}} میں مشینی ترجمہ۔ اصل پیغام اوپر ہے۔',
      hide: 'چھپائیں',
      show: 'دکھائیں',
      failed: 'ترجمہ نہیں ہو سکا۔ اصل پیغام نہیں بدلا۔',
    },
    composer: {
      lanes: 'جواب یا نوٹ لکھیں',
      replyLabel: '{{name}} کو جواب',
      noteLabel: 'اندرونی نوٹ',
      replyPlaceholder: '{{name}} کو جواب لکھیں…',
      notePlaceholder: 'اپنی ٹیم کے لیے نوٹ لکھیں…',
      send: 'بھیجیں',
      addNote: 'نوٹ شامل کریں',
      toSend: 'بھیجنے کے لیے',
      sent: 'جواب بھیج دیا گیا۔',
      noteAdded: 'نوٹ شامل کر دیا گیا۔',
      notSent: 'نہیں بھیجا گیا۔',
      saving: 'مسودہ محفوظ ہو رہا ہے…',
      saved: 'مسودہ محفوظ ہو گیا',
      savedHere: 'مسودہ اس براؤزر میں رکھا ہے',
      offlineSaved: 'آف لائن: مسودہ اس براؤزر میں رکھا ہے',
      hasDraft: '(مسودہ)',
      takesOver: 'جواب بھیجنے سے یہ گفتگو آپ کو سونپ دی جاتی ہے۔',
      takesOverAi: 'جواب بھیجنے سے گفتگو AI سے آپ کے پاس آ جاتی ہے۔',
      noReply: 'آپ کا کردار یہ گفتگو پڑھ سکتا ہے مگر جواب نہیں دے سکتا۔',
      noNote: 'آپ کا کردار یہاں نوٹ شامل نہیں کر سکتا۔',
      ownedByOther:
        '{{name}} یہ گفتگو سنبھال رہے ہیں۔ جواب دینے سے پہلے اسے سنبھالنے کی درخواست کریں۔',
      staleSend:
        'نہیں بھیجا گیا: کسی اور نے بدل دیا کہ یہ گفتگو کون سنبھالے گا۔ آپ کا متن نیچے رکھا ہے۔ گفتگو دیکھیں، پھر دوبارہ کوشش کریں۔',
      conflict: 'یہ مسودہ کسی دوسرے ٹیب یا آلے پر بدلا گیا۔',
      keepMine: 'میرا رکھیں',
      useTheirs: 'دوسرا نسخہ استعمال کریں',
    },
    outgoing: {
      label: 'ابھی نہ بھیجے گئے پیغامات',
      sending: 'بھیجا جا رہا ہے',
      failed: 'نہیں بھیجا گیا',
      ownership: 'بھیجنے سے پہلے کسی اور نے گفتگو سنبھال لی۔ صارف تک کچھ نہیں پہنچا۔',
      unavailable:
        'Chatwoot نے جواب نہیں دیا۔ دوبارہ بھیجنا محفوظ ہے: پیغام کبھی دو بار نہیں جاتا۔',
      other: 'یہ بھیجا نہیں جا سکا۔ دوبارہ کوشش کریں۔',
      retry: 'دوبارہ کوشش کریں',
      discard: 'ہٹائیں',
      discarded: 'ہٹا دیا گیا۔',
    },
    saved: {
      button: 'محفوظ جوابات',
      search: 'محفوظ جوابات تلاش کریں',
      none: 'کوئی محفوظ جواب نہیں ملا۔',
      missing: 'خود بھریں: {{names}}',
    },
    copilot: {
      button: 'جواب تجویز کریں',
      title: 'تجویز کردہ جواب',
      review: '{{name}} (AI) نے لکھا۔ بھیجنے سے پہلے جانچ لیں؛ کچھ بھی خود بخود نہیں بھیجا جاتا۔',
      noSources: 'کوئی ذریعہ استعمال نہیں ہوا۔',
      use: 'جواب میں ترمیم کریں',
      copy: 'کاپی کریں',
      sendAsMe: 'میرے نام سے بھیجیں',
      dismiss: 'تجویز ہٹائیں',
      ready: 'تجویز کردہ جواب تیار ہے۔',
      off: 'اس برانڈ کے لیے AI معاون بند ہے، اس لیے وہ جواب تجویز نہیں کر سکتا۔',
    },
    customer: {
      title: 'صارف',
      verifiedHint: 'برانڈ کی ویب سائٹ پر سائن اِن ہے؛ ان کی شناخت جانچی گئی۔',
      anonymousHint: 'سائن اِن نہیں۔ ان کا نام اور تفصیلات جانچی نہیں گئیں۔',
      email: 'ای میل',
      unverifiedEmail: 'دیا گیا ای میل',
      notVerified: '(غیر تصدیق شدہ)',
      externalId: 'صارف ID',
      language: 'زبان',
      brand: 'برانڈ',
      since: 'صارف کب سے',
      lastSeen: 'آخری بار دیکھے گئے',
      previous: 'دوسری گفتگوئیں',
      noPrevious: 'کوئی دوسری گفتگو نہیں جو آپ دیکھ سکیں۔',
    },
    tags: {
      title: 'ٹیگ',
      none: 'ابھی کوئی ٹیگ نہیں۔',
      add: 'ٹیگ شامل کریں',
      choose: 'ٹیگ منتخب کریں',
      addButton: 'شامل کریں',
      remove: 'ٹیگ {{name}} ہٹائیں',
      added: 'ٹیگ {{name}} شامل کیا گیا۔',
      removed: 'ٹیگ {{name}} ہٹایا گیا۔',
      noneDefined: 'اس برانڈ کے لیے ابھی کوئی ٹیگ نہیں بنے۔',
    },
    fields: {
      title: 'حسبِ ضرورت فیلڈز',
      none: 'اس برانڈ کے لیے کوئی حسبِ ضرورت فیلڈ نہیں بنی۔',
      save: 'فیلڈز محفوظ کریں',
      saved: 'فیلڈز محفوظ ہو گئیں۔',
    },
    links: {
      title: 'منسلک گفتگوئیں',
      none: 'کوئی منسلک گفتگو نہیں۔',
      other: 'منسلک کرنے کے لیے گفتگو ID',
      otherHint: 'جیسے conv_…؛ دونوں گفتگوئیں الگ رہتی ہیں۔',
      note: 'کیوں منسلک ہیں',
      add: 'منسلک کریں',
      added: 'گفتگوئیں منسلک ہو گئیں۔',
      remove: '{{name}} سے ربط ہٹائیں',
      removed: 'ربط ہٹا دیا گیا۔',
    },
    reviews: {
      title: 'سپروائزر کا جائزہ',
      none: 'ابھی کوئی جائزہ نہیں۔',
      rating: '5 میں سے {{rating}}',
      ratingLabel: 'درجہ بندی',
      note: 'رہنمائی کا نوٹ',
      save: 'جائزہ محفوظ کریں',
      saved: 'جائزہ محفوظ ہو گیا۔',
      by: 'از {{reviewer}}',
      byAbout: 'از {{reviewer}}، {{subject}} کے بارے میں',
    },
    bulk: {
      select: '{{name}} منتخب کریں',
      selected: '{{name}} منتخب ہوا۔ منتخب: {{n}}۔',
      unselected: '{{name}} کا انتخاب ہٹایا گیا۔ منتخب: {{n}}۔',
      count: 'منتخب: {{n}}',
      clear: 'انتخاب ہٹائیں',
      assignMe: 'مجھے سونپیں',
      resolve: 'حل کریں',
      reopen: 'دوبارہ کھولیں',
      tagLabel: 'شامل کرنے کے لیے ٹیگ',
      tagPlaceholder: 'شامل کرنے کے لیے ٹیگ',
      addTag: 'ٹیگ شامل کریں',
      confirmTitle: 'منتخب گفتگوئیں بدلیں؟',
      willChange: 'بدلی جا سکتی ہیں: {{n}}۔',
      cannotChange: 'نہیں بدلی جا سکتیں: {{n}}۔',
      apply: '{{n}} بدلیں',
      result: 'ہو گیا: {{done}}۔ ناکام: {{failed}}۔',
      partial: 'ہو گیا: {{done}}۔ نہیں بدلیں: {{failed}}۔ صرف انہی کو دوبارہ آزمایا جا سکتا ہے۔',
      retryFailed: 'ناکام والی دوبارہ آزمائیں',
      failed: 'نہیں بدلی',
    },
  },
  account: {
    title: 'اکاؤنٹ کی حفاظت',
    description: 'آپ Studio میں کیسے سائن اِن کرتے ہیں۔',
    twoFactor: {
      title: 'دو مرحلہ تصدیق',
      on: 'آن',
      off: 'آف',
      description:
        'سائن اِن کرتے وقت Studio تصدیقی ایپ سے ایک کوڈ مانگتا ہے۔ کچھ کاموں کے لیے یہ ضروری ہے۔',
      enable: 'آن کریں',
      disable: 'آف کریں',
      password: 'آپ کا پاس ورڈ',
      passwordHint: 'یہ ترتیب بدلنے کے لیے اپنا پاس ورڈ درج کریں۔',
      setupTitle: 'اپنی تصدیقی ایپ میں Hamnivo شامل کریں',
      setupBody: 'یہ سیٹ اپ کلید اپنی ایپ میں درج کریں، یا اس ڈیوائس پر لنک کھولیں۔',
      secret: 'سیٹ اپ کلید',
      openApp: 'تصدیقی ایپ میں کھولیں',
      backupTitle: 'اپنے بیک اپ کوڈز محفوظ کریں',
      backupBody:
        'فون گم ہونے پر ہر کوڈ سے آپ ایک بار سائن اِن کر سکتے ہیں۔ انہیں کسی محفوظ جگہ رکھیں۔ یہ صرف ابھی دکھائے جا رہے ہیں۔',
      copyCodes: 'بیک اپ کوڈز کاپی کریں',
      verify: 'تصدیق کریں اور آن کریں',
      enabled: 'دو مرحلہ تصدیق آن ہے۔',
      disabled: 'دو مرحلہ تصدیق آف ہے۔',
      disableBody:
        'سائن اِن میں صرف آپ کا پاس ورڈ مانگا جائے گا۔ جن کاموں کے لیے دو مرحلہ تصدیق ضروری ہے، وہ آپ کے لیے کام نہیں کریں گے۔',
      wrongPassword: 'یہ پاس ورڈ درست نہیں ہے۔',
    },
    passkeys: {
      title: 'پاس کیز',
      description: 'پاس ورڈ کے بجائے اپنی ڈیوائس کے اسکرین لاک سے سائن اِن کریں۔',
      add: 'پاس کی شامل کریں',
      added: 'پاس کی شامل ہو گئی۔',
      failed: 'پاس کی شامل نہیں ہوئی۔ دوبارہ کوشش کریں۔',
      unsupported: 'یہ براؤزر پاس کیز استعمال نہیں کر سکتا۔',
      none: 'ابھی کوئی پاس کی نہیں۔',
      created: 'شامل کی گئی: {{time}}',
      unnamed: 'پاس کی',
      loading: 'پاس کیز لوڈ ہو رہی ہیں',
    },
  },
  decisions: decisionsUr,
  checks: checksUr,
  caching: cachingUr,
  tools: toolsUr,
  commerce: commerceUr,
  developer: developerUr,
  reports: reportsUr,
  privacy: privacyUr,
  chatSettings: chatSettingsUr,
  chatWidget: chatWidgetUr,
  channels: channelsUr,
  automations: automationsUr,
  memory: {
    title: 'کسٹمر میموری',
    description: 'طے کریں کہ ہم آپ کے کسٹمرز کے بارے میں کیا یاد رکھتے ہیں۔',
    allCustomers: 'تمام کسٹمرز',
    loading: 'کسٹمر میموری لوڈ ہو رہی ہے',
    notOffered:
      'اس برانڈ کا AI ایجنٹ ابھی میموری استعمال نہیں کرتا، اس لیے یہاں کی کوئی چیز جوابات میں استعمال نہیں ہوتی۔',
    exported: 'میموری ایکسپورٹ ہو گئی۔',
    forbidden: {
      title: 'آپ کسٹمر میموری نہیں دیکھ سکتے',
      description: 'اس ورک اسپیس کے ایڈمن سے کسٹمر میموری کی اجازت مانگیں۔',
    },
    list: {
      title: 'کسٹمرز',
      search: 'کسٹمر تلاش کریں',
      searchHint: 'نام، ای میل یا کسٹمر ID۔',
      searchLabel: 'کسٹمر میموری میں تلاش',
      submit: 'تلاش کریں',
      brand: 'برانڈ',
      allBrands: 'تمام برانڈز',
      loading: 'کسٹمرز لوڈ ہو رہے ہیں',
      toReview: 'جائزے کے لیے: {{total}}',
      columns: {
        customer: 'کسٹمر',
        brand: 'برانڈ',
        choice: 'میموری',
        remembered: 'یاد رکھا گیا',
        review: 'جائزہ ضروری',
        changed: 'آخری تبدیلی',
      },
      empty: {
        title: 'ابھی کوئی کسٹمر میموری نہیں',
        description:
          'کسٹمرز چیٹ میں یاد رکھے جانے کی رضامندی کے بعد یہاں نظر آتے ہیں۔ AI ایجنٹ کی سیٹنگز میں میموری آن کریں۔',
        action: 'AI ایجنٹس کھولیں',
      },
      noMatch: {
        title: 'کوئی کسٹمر نہیں ملا',
        description: 'کوئی اور نام، ای میل یا کسٹمر ID آزمائیں۔',
      },
    },
    customer: {
      anonymous: 'نامعلوم کسٹمر',
      unnamed: 'سائن اِن کسٹمر',
      verified: 'سائن اِن',
      notVerified: 'سائن اِن نہیں',
      since: '{{date}} سے کسٹمر',
    },
    consent: {
      granted: 'میموری آن',
      declined: 'انکار کیا',
      withdrawn: 'میموری بند',
      undecided: 'ابھی پوچھا نہیں گیا',
      history: 'انتخاب کی تاریخ',
      by: {
        customer: 'کسٹمر کی طرف سے',
        staff: 'اسٹاف کی طرف سے',
      },
      line: {
        granted: '{{date}} کو رضامندی دی',
        declined: '{{date}} کو انکار کیا',
        withdrawn: '{{date}} کو بند کی',
        undecided: 'کسٹمر نے ابھی انتخاب نہیں کیا۔',
      },
    },
    status: {
      active: 'موجودہ',
      pending: 'جائزہ ضروری',
      superseded: 'تبدیل شدہ',
      outdated: 'پرانا',
    },
    sources: {
      customer_statement: 'کسٹمر کا پیغام',
      customer_control: 'کسٹمر نے سیٹ کیا',
      staff_entry: 'اسٹاف نے درج کیا',
      agent_inference: 'اندازہ',
      system_record: 'سسٹم ریکارڈ',
      import: 'امپورٹ شدہ',
    },
    writers: {
      ai: 'AI اسسٹنٹ',
      staff: 'اسٹاف ممبر',
      customer: 'کسٹمر',
      system: 'Hamnivo',
    },
    reasons: {
      extracted_from_message: 'کسٹمر کے پیغام سے',
      customer_correction: 'کسٹمر نے درست کیا',
      customer_confirmation: 'کسٹمر نے تصدیق کی',
      staff_correction: 'اسٹاف نے درست کیا',
      staff_confirmation: 'اسٹاف نے تصدیق کی',
    },
    scope: {
      short: {
        person: 'یہ کسٹمر',
        conversation: 'صرف یہ چیٹ',
      },
      long: {
        person: 'یہ کسٹمر، اس برانڈ کی ہر چیٹ میں',
        conversation: 'صرف وہ چیٹ جہاں سے یہ آیا',
      },
    },
    slots: {
      preferred_language: {
        label: 'پسندیدہ زبان',
        purpose: 'کسٹمر کی زبان میں جواب دینا',
      },
      preferred_name: {
        label: 'پسندیدہ نام',
        purpose: 'کسٹمر کو ان کے کہنے کے مطابق مخاطب کرنا',
      },
      contact_method: {
        label: 'رابطے کی پسند',
        purpose: 'ان کا پسندیدہ رابطے کا طریقہ استعمال کرنا',
      },
      contact_time: {
        label: 'رابطے کا بہترین وقت',
        purpose: 'ان کی سہولت کے وقت رابطہ کرنا',
      },
      communication_style: {
        label: 'جواب کا انداز',
        purpose: 'ان کی پسند کے انداز میں جواب دینا',
      },
      delivery_note: {
        label: 'ڈیلیوری نوٹ',
        purpose: 'آسان ڈیلیوری یقینی بنانا',
      },
      product_interest: {
        label: 'پروڈکٹ میں دلچسپی',
        purpose: 'جس کے بارے میں پوچھا، وہ تجویز کرنا',
      },
      size_preference: {
        label: 'سائز',
        purpose: 'درست سائز تجویز کرنا',
      },
      open_issue: {
        label: 'کھلی درخواست',
        purpose: 'دوبارہ پوچھے بغیر آگے بڑھنا',
      },
      stated_order_reference: {
        label: 'بتایا گیا آرڈر',
        purpose: 'ان کا آرڈر جلد ڈھونڈنا',
      },
    },
    tabs: {
      preferences: 'پسند',
      facts: 'گفتگو کی معلومات',
      notes: 'ایجنٹ کے نوٹس',
      internal: 'صرف اندرونی',
    },
    table: {
      title: 'ہم کیا یاد رکھتے ہیں',
      columns: {
        memory: 'میموری',
        purpose: 'مقصد',
        source: 'ذریعہ',
        confirmed: 'آخری تصدیق',
        visibility: 'کون دیکھتا ہے',
      },
      noMatch: 'آپ کی تلاش سے کچھ نہیں ملا۔',
      emptyPreferences: 'کوئی پسند یاد نہیں رکھی گئی۔',
      emptyFacts: 'گفتگو کی کوئی معلومات یاد نہیں رکھی گئی۔',
      searchPreferences: 'کسٹمر کی پسند تلاش کریں…',
      searchFacts: 'گفتگو کی معلومات تلاش کریں…',
      notes:
        'اسسٹنٹ کسٹمرز کے بارے میں کوئی نوٹس نہیں رکھتا۔ وہ صرف وہی یاد رکھتا ہے جو کسٹمرز رضامندی کے بعد بتاتے ہیں۔',
    },
    panel: {
      pick: 'کوئی میموری کہاں سے آئی، یہ دیکھنے کے لیے اسے منتخب کریں۔',
      onlyApproved: 'کسٹمرز کے جوابات میں صرف منظور شدہ قدریں استعمال ہوتی ہیں۔',
      value: 'موجودہ قدر',
      status: 'حالت',
      purpose: 'مقصد',
      source: 'ذریعہ',
      messages: 'پیغام:',
      conversation: 'گفتگو:',
      recordedBy: 'کس نے درج کیا',
      note: 'تبدیلی کی وجہ',
      scope: 'دائرہ',
      inEffect: 'کب سے نافذ',
      expires: 'میعاد',
      noExpiry: 'کوئی آخری تاریخ نہیں',
      verified: 'تصدیق',
      notVerified: 'تصدیق نہیں ہوئی۔ یہ کسٹمر کا کہنا ہے۔',
      version: 'ورژن',
      edit: 'قدر میں ترمیم',
      newValue: 'نئی قدر',
      correctionReason: 'درستی کی وجہ',
      valueRequired: 'نئی قدر لکھیں۔',
      valueSame: 'موجودہ قدر سے مختلف قدر لکھیں۔',
      saved: 'درستی محفوظ ہو گئی۔ پرانی قدر تاریخ میں رہتی ہے۔',
      unchanged: 'کچھ نہیں بدلا: یہ قدر پہلے سے یاد ہے۔',
      history: 'تاریخ',
      historyLine: '{{writer}} · {{from}} سے {{until}} تک',
    },
    reason: {
      label: 'وجہ',
      hint: 'ذاتی تفصیلات شامل نہ کریں۔ وجہ تبدیلی کے ساتھ رکھی جاتی ہے۔',
      required: 'وجہ لکھیں۔',
    },
    actions: {
      export: 'ایکسپورٹ',
      erase: 'تمام میموری مٹائیں',
      outdated: 'پرانا نشان زد کریں',
      delete: 'حذف کریں',
      save: 'درستی محفوظ کریں',
    },
    conflict: {
      title: 'ایک نیا پیغام “{{label}}” کو بدل سکتا ہے',
      body: '{{date}} کا ایک نیا پیغام ہے۔ جائزہ لیں اور تصدیق کریں کہ کون سا رکھنا ہے۔',
      bodyNoCurrent: '{{date}} کے ایک پیغام میں ایک قدر ہے جو جائزے کی منتظر ہے۔',
      customerCan:
        'کسٹمر بھی چیٹ میں اس کی تصدیق کر سکتے ہیں۔ تب تک کوئی بھی قدر جوابات میں استعمال نہیں ہوتی۔',
      compare: 'موازنہ کریں',
      confirm: 'نئی قدر کی تصدیق کریں',
      keep: 'موجودہ قدر رکھیں',
      compareTitle: 'قدروں کا موازنہ',
      current: 'موجودہ',
      newer: 'نیا پیغام',
      none: 'کوئی نہیں',
    },
    confirmReview: {
      title: 'نئی “{{label}}” کی تصدیق کریں؟',
      body: 'نئی قدر موجودہ کی جگہ لے گی، اور موجودہ تاریخ میں رہے گی۔',
      done: 'نئی قدر کی تصدیق ہو گئی۔',
    },
    reject: {
      title: 'موجودہ قدر رکھیں؟',
      body: 'نئی قدر حذف ہو جائے گی اور استعمال نہیں ہوگی۔ حذف کرنے کا ریکارڈ رکھا جائے گا۔',
    },
    outdated: {
      title: 'اس میموری کو پرانا نشان زد کریں؟',
      body: 'یہ اب جوابات میں استعمال نہیں ہوگی۔ حذف ہونے یا میعاد ختم ہونے تک یہ تاریخ میں رہے گی۔',
      submit: 'پرانا نشان زد کریں',
      done: 'پرانا نشان زد کر دیا گیا۔',
    },
    delete: {
      title: 'یہ میموری حذف کریں؟',
      intro: 'اس سے یہ میموری استعمال سے ہٹ جائے گی:',
      body: 'یہ اب کسٹمرز کے جوابات میں استعمال نہیں ہوگی، لیکن آڈٹ ریکارڈ رکھا جائے گا۔',
      bodyPending: 'جائزے کی منتظر قدر ہٹا دی جائے گی۔ آڈٹ ریکارڈ رکھا جائے گا۔',
      submit: 'استعمال سے ہٹائیں',
    },
    erase: {
      title: '{{name}} کے بارے میں تمام میموری مٹائیں؟',
      body: 'یاد رکھی گئی تمام قدریں ({{total}}) اور ان کی تاریخ، تلاش کے انڈیکس سمیت، حذف ہو جائیں گی۔',
      kept: 'چیٹ کی تاریخ، آڈٹ لاگ اور حذف کا ریکارڈ رکھے جاتے ہیں۔',
      submit: 'تمام میموری مٹائیں',
      turnOff: 'اس کسٹمر کے لیے میموری بھی بند کریں',
      turnOffHint: 'کسٹمر کی دوبارہ رضامندی تک کچھ نیا یاد نہیں رکھا جائے گا۔',
    },
    notice: {
      removed: 'استعمال سے ہٹا دیا گیا۔',
      erased: 'اس کسٹمر کی تمام میموری مٹا دی گئی۔',
      pending: 'منسلک انڈیکس اپ ڈیٹ ہو رہے ہیں۔ اس میں چند منٹ لگ سکتے ہیں۔',
      completed: 'انڈیکس اور کیش صاف ہو گئے۔ حذف مکمل ہو گیا۔',
    },
    deletions: {
      title: 'حذف شدہ ریکارڈ اور آڈٹ ٹریل',
      description: 'کیا حذف ہوا، کس نے کیا، اور کیا رکھا گیا۔',
      steps: 'حذف کے مراحل',
      line: '{{who}} · {{reason}} · {{time}}',
      kept: 'رکھا گیا: {{items}}۔',
      status: {
        pending: 'جاری ہے',
        completed: 'مکمل',
      },
      scope: {
        record: 'میموری حذف ہوئی (ریکارڈ: {{total}})',
        customer: 'تمام میموری مٹائی گئی (ریکارڈ: {{total}})',
      },
      requester: {
        customer: 'کسٹمر',
        staff: 'اسٹاف ممبر',
        system: 'Hamnivo',
      },
      reasons: {
        customer_request: 'کسٹمر کی درخواست',
        staff_request: 'اسٹاف کی درخواست',
        erasure_request: 'مٹانے کی درخواست',
        retention_expired: 'رکھنے کی مدت ختم',
        review_rejected: 'جائزے میں مسترد',
      },
      stepNames: {
        records: 'ریکارڈ',
        embeddings: 'تلاش کا انڈیکس',
        citations: 'حوالے',
        caches: 'کیش',
        verification: 'تصدیق',
      },
      keptNames: {
        audit_log: 'آڈٹ لاگ',
        consent_log: 'میموری کے انتخاب',
        deletion_record: 'حذف کا ریکارڈ',
        chat_history: 'چیٹ کی تاریخ',
      },
    },
  },
  access: {
    settings: 'ترتیبات',
    you: 'آپ',
    anyone: 'کوئی بھی',
    copyFailed: 'کاپی نہیں ہو سکا۔ متن منتخب کر کے خود کاپی کریں۔',
    copyValue: '{{label}} کاپی کریں',
    scope: {
      tenant: 'پوری ورک اسپیس',
      workspace: 'ورک اسپیس کا حصہ: {{name}}',
      brand: 'برانڈ: {{name}}',
      team: 'ٹیم: {{name}}',
      inbox: 'ان باکس',
      unknown: 'ورک اسپیس کا ایک حصہ',
    },
    scopeTypes: {
      tenant: 'پوری ورک اسپیس',
      workspace: 'ورک اسپیس کا ایک حصہ',
      brand: 'ایک برانڈ',
      team: 'ایک ٹیم',
    },
    team: {
      title: 'ٹیم اور رسائی',
      description:
        'طے کریں کہ یہ ورک اسپیس کون استعمال کر سکتا ہے، ان کے کردار کیا ہیں اور وہ کیا کر سکتے ہیں۔',
      tabs: { members: 'اراکین', roles: 'کردار', audit: 'آڈٹ لاگ' },
      invite: 'ساتھی کو مدعو کریں',
      search: 'اراکین تلاش کریں',
      searchPlaceholder: 'نام یا ای میل',
      activeCount: 'فعال اراکین: {{n}}',
      loading: 'اراکین لوڈ ہو رہے ہیں',
      noMatches: '“{{query}}” سے کوئی رکن نہیں ملتا۔',
      clearSearch: 'تلاش صاف کریں',
      columns: {
        name: 'نام',
        role: 'کردار',
        teams: 'ٹیمیں',
        lastActive: 'آخری بار فعال',
        status: 'حیثیت',
        actions: 'اقدامات',
      },
      status: {
        active: 'فعال',
        suspended: 'معطل',
        invited: 'دعوت باقی',
        expired: 'دعوت کی مدت ختم',
        removed: 'ہٹا دیا گیا',
      },
      noTeams: 'کوئی ٹیم نہیں',
      noRole: 'کوئی کردار نہیں',
      notYet: 'ابھی نہیں',
      invitedOn: '{{time}} کو مدعو کیا',
      until: '{{time}} تک',
      actionsFor: '{{name}} کے لیے اقدامات',
      changeAccess: 'کردار یا دائرہ بدلیں',
      suspend: 'معطل کریں',
      restore: 'رسائی بحال کریں',
      remove: 'ورک اسپیس سے ہٹائیں',
      resend: 'دعوت دوبارہ بھیجیں',
      revokeInvite: 'دعوت منسوخ کریں',
      beyondReach: 'ان کی رسائی آپ کی رسائی سے زیادہ ہے، اس لیے آپ اسے نہیں بدل سکتے۔',
      selfNote: 'آپ یہاں اپنی رسائی نہیں بدل سکتے۔',
      suspendTitle: '{{name}} کو معطل کریں؟',
      suspendBody:
        'ان کی اس ورک اسپیس تک رسائی فوراً ختم ہو جاتی ہے، اور کوئی دوسری ورک اسپیس نہ ہونے پر وہ سائن آؤٹ ہو جاتے ہیں۔ ان کی گفتگو جہاں ہے وہیں رہتی ہے۔ آپ انہیں بعد میں بحال کر سکتے ہیں۔',
      suspendSubmit: 'معطل کریں',
      suspended: '{{name}} معطل ہیں۔',
      restoreTitle: '{{name}} کو بحال کریں؟',
      restoreBody:
        'انہیں پہلے والے کردار واپس ملتے ہیں۔ جاری رکھنے کے لیے وہ دوبارہ سائن اِن کرتے ہیں۔',
      restoreSubmit: 'بحال کریں',
      restored: '{{name}} کو دوبارہ رسائی مل گئی۔',
      revokeInviteTitle: '{{email}} کی دعوت منسوخ کریں؟',
      revokeInviteBody: 'ان کی ای میل میں موجود لنک کام کرنا بند کر دیتا ہے۔',
      revokeInviteSubmit: 'دعوت منسوخ کریں',
      inviteRevoked: '{{email}} کی دعوت منسوخ کر دی گئی۔',
      resent: '{{email}} کو دعوت کا نیا لنک بھیجا گیا۔ پرانا لنک اب کام نہیں کرتا۔',
      recent: 'حالیہ سرگرمی',
      recentLoading: 'حالیہ سرگرمی لوڈ ہو رہی ہے',
      recentEmpty: 'ابھی تک کچھ نہیں ہوا۔',
      viewAudit: 'آڈٹ لاگ کھولیں',
    },
    inviteDialog: {
      title: 'ساتھی کو مدعو کریں',
      description: 'انہیں اس ورک اسپیس میں شامل ہونے کے لنک والی ای میل ملتی ہے۔',
      email: 'ای میل پتہ',
      emailInvalid: 'name@example.com جیسا ای میل پتہ درج کریں۔',
      role: 'کردار',
      roleBeyond: '{{name}} (آپ کی رسائی سے باہر)',
      where: 'کردار کہاں لاگو ہوتا ہے',
      workspace: 'ورک اسپیس کا حصہ',
      team: 'ٹیم',
      brand: 'برانڈ',
      pick: 'ایک منتخب کریں',
      pickRequired: 'منتخب کریں کہ کردار کہاں لاگو ہوتا ہے۔',
      expires: 'رسائی کب ختم ہو',
      expiresHint: 'خالی چھوڑیں تاکہ رسائی تب تک رہے جب تک کوئی اسے نہ بدلے۔',
      submit: 'دعوت بھیجیں',
      sent: '{{email}} کو دعوت بھیج دی گئی۔ لنک 7 دن تک کام کرتا ہے۔',
      copyLink: 'دعوت کا لنک کاپی کریں',
      linkHint: 'اگر اس سرور پر ای میل سیٹ نہیں ہے تو یہ لنک انہیں خود بھیجیں۔',
      done: 'ہو گیا',
    },
    changeDialog: {
      title: '{{name}} کی رسائی',
      description:
        'ہر کردار وہیں لاگو ہوتا ہے جہاں دیا گیا تھا۔ تبدیلیاں ان کی اگلی درخواست پر لاگو ہوتی ہیں۔',
      current: 'موجودہ کردار',
      none: 'کوئی کردار نہیں۔ وہ سائن اِن کر سکتے ہیں لیکن یہاں کچھ نہیں کر سکتے۔',
      change: 'بدلیں',
      removeRole: 'کردار ہٹائیں',
      removeRoleLabel: '{{name}} سے {{role}} ہٹائیں',
      removeRoleTitle: '{{name}} سے {{role}} ہٹائیں؟',
      removeRoleBody: 'اگلی درخواست پر ان کے پاس وہ نہیں رہے گا جو یہ کردار دیتا ہے۔',
      add: 'ایک اور کردار شامل کریں',
      editTitle: '{{role}} بدلیں',
      addTitle: 'کردار شامل کریں',
      reason: 'وجہ',
      reasonHint: 'آڈٹ لاگ میں محفوظ ہوتی ہے۔',
      save: 'رسائی محفوظ کریں',
      saved: '{{name}} کی رسائی بدل دی گئی۔',
      back: 'کرداروں پر واپس جائیں',
    },
    offboard: {
      title: '{{name}} کو ہٹائیں؟',
      loading: 'جانچ ہو رہی ہے کہ ان کے پاس کیا ہے',
      body: 'ان کی اس ورک اسپیس تک رسائی فوراً ختم ہو جاتی ہے۔ ان کے کردار ہٹا دیے جاتے ہیں، وہ اپنی ٹیموں سے نکل جاتے ہیں اور ان کے پتے کی باقی دعوتیں کام کرنا بند کر دیتی ہیں۔ ان کا پچھلا کام تاریخ میں برقرار رہتا ہے۔',
      conversations: 'انہیں سونپی گئی کھلی گفتگو: {{n}}۔',
      noConversations: 'ان کی کوئی کھلی گفتگو نہیں ہے۔',
      reassign: 'پہلے ان کی کھلی گفتگو کسی اور کو سونپیں',
      reassignTo: 'کسے سونپیں',
      queue: 'ٹیم کی قطار میں واپس',
      cantReassign:
        'آپ گفتگو دوبارہ نہیں سونپ سکتے۔ جب تک رسائی والا کوئی انہیں دوبارہ نہ سونپے، یہ ان کا انتظار کرتی رہیں گی۔',
      reason: 'وجہ',
      reasonHint: 'آڈٹ لاگ میں محفوظ ہوتی ہے۔',
      submit: '{{name}} کو ہٹائیں',
      reassigning: 'گفتگو دوبارہ سونپی جا رہی ہے',
      reassigned: 'دوبارہ سونپی گئی گفتگو: {{n}}۔',
      reassignFailed: 'جو گفتگو دوبارہ نہیں سونپی جا سکی: {{n}}۔ {{name}} کو نہیں ہٹایا گیا۔',
      removed: '{{name}} کو اس ورک اسپیس سے ہٹا دیا گیا۔',
      ownerTitle: 'اس مالک کو ہٹانے سے پہلے کسی اور کو مالک بنائیں',
      ownerBody:
        'ورک اسپیس میں ہمیشہ کم از کم ایک مالک ہونا چاہیے۔ پہلے کسی اور کو مالک بنائیں، پھر دوبارہ کوشش کریں۔',
      goToMembers: 'اراکین پر جائیں',
    },
    roles: {
      intro:
        'بلٹ اِن کردار عام کاموں کے لیے ہیں۔ حسبِ ضرورت کردار بالکل وہی اجازتیں دیتے ہیں جو آپ منتخب کرتے ہیں۔',
      new: 'نیا کردار',
      loading: 'کردار لوڈ ہو رہے ہیں',
      builtIn: 'بلٹ اِن',
      custom: 'حسبِ ضرورت',
      members: 'اراکین: {{n}}',
      permissions: 'اجازتیں: {{n}}',
      open: '{{name}} کھولیں',
      readOnly: 'صرف پڑھنے کے لیے',
      editorNew: 'نیا کردار',
      summary: '{{kind}} · {{members}}',
      name: 'نام',
      key: 'کلید',
      keyHint:
        'چھوٹے انگریزی حروف، ہندسے اور _، API میں استعمال ہوتی ہے۔ بعد میں بدلی نہیں جا سکتی۔',
      keyInvalid: '2 سے 40 چھوٹے حروف، ہندسے یا _ استعمال کریں، شروعات حرف سے ہو۔',
      nameRequired: 'نام درج کریں۔',
      description: 'یہ کردار کس لیے ہے',
      permissionsLegend: 'اجازتیں',
      pickOne: 'کم از کم ایک اجازت منتخب کریں۔',
      notGrantable: 'آپ کی رسائی سے باہر',
      stepUp: 'حال ہی میں سائن اِن ضروری',
      mfa: 'دو مرحلہ تصدیق ضروری',
      presetNote:
        'بلٹ اِن کردار بدلے نہیں جا سکتے۔ کسی کی نقل بنا کر ایسا حسبِ ضرورت کردار بنائیں جسے آپ بدل سکیں۔',
      beyondNote: 'اس کردار میں ایسی رسائی ہے جو آپ کے پاس نہیں، اس لیے آپ اسے نہیں بدل سکتے۔',
      duplicate: 'حسبِ ضرورت کردار کے طور پر نقل بنائیں',
      copyName: '{{name}} (نقل)',
      preview: 'محفوظ کرنے سے کیا بدلے گا',
      previewLoading: 'تبدیلی کی جانچ ہو رہی ہے',
      previewNothing: 'ابھی کچھ نہیں بدلتا۔',
      adds: 'شامل کرتا ہے',
      removes: 'ہٹاتا ہے',
      sensitive: 'اضافی جانچ ضروری: {{list}}',
      outside: 'آپ یہ شامل نہیں کر سکتے: {{list}}',
      impact: 'کس پر اثر پڑے گا',
      impactNone: 'ابھی یہ کردار کسی کے پاس نہیں ہے۔',
      gains: 'کو ملے گا: {{list}}',
      loses: 'سے ہٹے گا: {{list}}',
      unchanged: 'کوئی تبدیلی نہیں',
      save: 'تبدیلیاں محفوظ کریں',
      create: 'کردار بنائیں',
      saved: 'کردار {{name}} محفوظ ہو گیا۔',
      created: 'کردار {{name}} بن گیا۔',
      conflict:
        'آپ کے تبدیلیاں کرتے وقت کسی اور نے یہ کردار بدل دیا۔ ان کے ورژن سے موازنہ کریں: آپ کی تبدیلیاں برقرار رہیں گی، اور پیش منظر دکھائے گا کہ محفوظ کرنے سے ان کے ورژن میں کیا بدلے گا۔',
      reload: 'ان کے ورژن سے موازنہ کریں',
      archive: 'کردار ریٹائر کریں',
      archiveTitle: '{{name}} کو ریٹائر کریں؟',
      archiveBody:
        'یہ فہرست سے ہٹ جاتا ہے۔ پرانی منظوریوں اور آڈٹ لاگ میں اس کا نام برقرار رہتا ہے۔ صرف وہی کردار ریٹائر ہو سکتا ہے جو کسی کے پاس نہ ہو۔',
      archiveSubmit: 'کردار ریٹائر کریں',
      archived: 'کردار {{name}} ریٹائر کر دیا گیا۔',
      heldNote: 'یہ کردار کچھ لوگوں کے پاس ہے۔ ریٹائر کرنے سے پہلے ان کی رسائی بدلیں۔',
      close: 'کردار بند کریں',
      discardTitle: 'اس کردار میں کی گئی تبدیلیاں چھوڑ دیں؟',
      discardBody: 'یہاں کی گئی تبدیلیاں ابھی محفوظ نہیں ہوئیں۔',
    },
    audit: {
      intro: 'رسائی، ترتیبات اور ڈیٹا کی ہر تبدیلی، ترتیب سے۔ اندراجات بدلے یا ہٹائے نہیں جا سکتے۔',
      loading: 'آڈٹ لاگ لوڈ ہو رہا ہے',
      filters: 'فلٹرز',
      action: 'عمل',
      actionPlaceholder: 'مثلاً member.removed',
      actor: 'کس نے',
      target: 'ہدف کی ID',
      targetPlaceholder: 'مثلاً stf_…',
      from: 'سے',
      to: 'تک',
      apply: 'فلٹرز لاگو کریں',
      clear: 'فلٹرز صاف کریں',
      applied: 'دکھایا جا رہا ہے: {{list}}',
      empty: 'ان فلٹرز سے کوئی اندراج نہیں ملتا۔',
      columns: {
        time: 'وقت',
        actor: 'کس نے',
        action: 'کیا',
        target: 'ہدف',
        outcome: 'نتیجہ',
        details: 'تفصیلات',
      },
      outcomes: { success: 'ہو گیا', denied: 'مسترد', failed: 'ناکام' },
      actorTypes: {
        staff: 'ٹیم کا رکن',
        service_account: 'API کلید',
        customer: 'کسٹمر',
        ai: 'AI',
        system: 'Hamnivo',
        platform: 'Hamnivo سپورٹ',
      },
      reason: 'وجہ: {{reason}}',
      showData: 'درج شدہ ڈیٹا دکھائیں',
      loadMore: 'پرانے اندراجات لوڈ کریں',
      verify: 'سالمیت جانچیں',
      verifyOk: 'آڈٹ لاگ درست ہے۔ جانچے گئے اندراجات: {{n}}۔',
      verifyBroken: 'آڈٹ لاگ اندراج {{seq}} پر ٹوٹا ہوا ہے۔ یہ نمبر بتا کر سپورٹ سے رابطہ کریں۔',
      export: 'ایکسپورٹ کریں',
      exportCsv: 'CSV کے طور پر ایکسپورٹ کریں (اسپریڈشیٹ)',
      exportNdjson: 'NDJSON کے طور پر ایکسپورٹ کریں (ہیش سمیت)',
      exporting: 'ایکسپورٹ تیار ہو رہا ہے',
      exported: 'ایکسپورٹ ڈاؤن لوڈ ہو گیا۔ یہ آڈٹ لاگ میں درج ہے۔',
      exportNote: 'ایکسپورٹ اوپر کے فلٹرز کے مطابق ہوتے ہیں اور آڈٹ لاگ میں درج ہوتے ہیں۔',
      forbiddenExport: 'ایکسپورٹ کے لیے آڈٹ ایکسپورٹ کی اجازت ضروری ہے۔',
    },
    auditActions: {
      tenant: { created: 'ورک اسپیس بنائی گئی' },
      member: {
        suspended: 'رکن معطل',
        restored: 'رکن بحال',
        removed: 'رکن ہٹایا گیا',
        sessions_ended: 'سیشن ختم کیے گئے',
        joined_by_sso: 'سنگل سائن آن سے شامل ہوئے',
        sso_join_skipped: 'سنگل سائن آن سے شمولیت چھوڑی گئی',
      },
      invitation: {
        created: 'دعوت بھیجی گئی',
        resent: 'دعوت دوبارہ بھیجی گئی',
        revoked: 'دعوت منسوخ کی گئی',
        accepted: 'دعوت قبول کی گئی',
      },
      grant: { created: 'کردار دیا گیا', revoked: 'کردار ہٹایا گیا', replaced: 'کردار بدلا گیا' },
      role: {
        created: 'کردار بنایا گیا',
        updated: 'کردار بدلا گیا',
        archived: 'کردار ریٹائر کیا گیا',
      },
      audit: { exported: 'آڈٹ لاگ ایکسپورٹ کیا گیا' },
      sso: {
        domain_added: 'ڈومین شامل کیا گیا',
        domain_verified: 'ڈومین کی تصدیق ہو گئی',
        domain_check_failed: 'ڈومین کی جانچ ناکام',
        domain_removed: 'ڈومین ہٹایا گیا',
        connection_created: 'سنگل سائن آن جوڑا گیا',
        connection_updated: 'سنگل سائن آن بدلا گیا',
        connection_removed: 'سنگل سائن آن ہٹایا گیا',
        sign_in_refused: 'سنگل سائن آن سے سائن اِن مسترد',
      },
      operator: {
        appointed: 'پلیٹ فارم آپریٹر مقرر',
        role_changed: 'پلیٹ فارم آپریٹر کا کردار بدلا',
        disabled: 'پلیٹ فارم آپریٹر غیر فعال',
      },
      incident: { declared: 'واقعہ کا اعلان کیا گیا', resolved: 'واقعہ حل کیا گیا' },
      support: {
        requested: 'سپورٹ نے رسائی مانگی',
        approved: 'سپورٹ کی رسائی منظور',
        declined: 'سپورٹ کی رسائی مسترد',
        revoked: 'سپورٹ کی رسائی منسوخ',
        ended: 'سپورٹ کی رسائی ختم',
        accessed: 'سپورٹ نے ڈیٹا پڑھا',
      },
    },
    security: {
      title: 'سیکیورٹی',
      description: 'آپ کے ای میل ڈومین کے لیے سنگل سائن آن، اور Hamnivo سپورٹ کے لیے عارضی رسائی۔',
      sso: {
        title: 'سنگل سائن آن (SSO)',
        description:
          'آپ کے ڈومین کے پتے والے لوگ آپ کے شناختی فراہم کنندہ (OpenID Connect) سے سائن اِن کرتے ہیں۔',
        loading: 'سنگل سائن آن لوڈ ہو رہا ہے',
        forbidden: 'سنگل سائن آن ورک اسپیس کے مالکان اور منتظمین سنبھالتے ہیں۔',
        steps: 'ثابت کریں کہ ڈومین آپ کا ہے، اپنا شناختی فراہم کنندہ جوڑیں، پھر اسے آن کریں۔',
        domains: 'ای میل ڈومینز',
        addDomain: 'ڈومین شامل کریں',
        domain: 'ڈومین',
        domainHint: 'آپ کی ٹیم کے پتوں میں @ کے بعد والا حصہ، جیسے northline.example۔',
        domainInvalid: 'northline.example جیسا ڈومین درج کریں۔',
        noDomains: 'ابھی کوئی ڈومین نہیں۔',
        verified: 'تصدیق شدہ',
        pending: 'DNS ریکارڈ کا انتظار',
        publish:
          'یہ TXT ریکارڈ اپنے DNS فراہم کنندہ پر شائع کریں، پھر اسے جانچیں۔ ریکارڈ ظاہر ہونے میں کچھ وقت لگ سکتا ہے۔',
        recordName: 'نام',
        recordValue: 'قدر',
        check: 'ابھی جانچیں',
        checked: 'آخری جانچ {{time}}',
        results: {
          verified: 'ریکارڈ مل گیا۔ ڈومین کی تصدیق ہو گئی۔',
          not_found: 'ریکارڈ ابھی نہیں ملا۔ نام اور قدر جانچیں، پھر بعد میں دوبارہ کوشش کریں۔',
          lookup_failed: 'DNS تلاش ناکام رہی۔ چند منٹ بعد دوبارہ کوشش کریں۔',
          claimed_elsewhere:
            'کسی اور ورک اسپیس نے یہ ڈومین پہلے ہی تصدیق کر لیا ہے۔ اگر یہ غلط ہے تو Hamnivo سپورٹ سے رابطہ کریں۔',
        },
        removeDomain: 'ڈومین ہٹائیں',
        removeDomainLabel: '{{domain}} ہٹائیں',
        removeDomainTitle: '{{domain}} ہٹائیں؟',
        removeDomainBody:
          'آپ اسے بعد میں دوبارہ شامل کر سکتے ہیں، لیکن اس کی دوبارہ تصدیق کرنی ہوگی۔',
        connection: '{{domain}} کے لیے شناختی فراہم کنندہ',
        connectHint:
          'اپنے فراہم کنندہ پر ایک OpenID Connect ایپ بنائیں، پھر اس کی تفصیلات یہاں درج کریں۔',
        issuer: 'جاری کنندہ کا URL (Issuer URL)',
        issuerHint: 'مثلاً https://login.example.com۔ Hamnivo اس کی ڈسکوری دستاویز پڑھتا ہے۔',
        issuerInvalid: 'جاری کنندہ کا URL درج کریں، جو https:// سے شروع ہو۔',
        clientId: 'کلائنٹ ID',
        clientSecret: 'کلائنٹ سیکرٹ',
        clientSecretHint:
          'خفیہ کر کے رکھا جاتا ہے۔ یہ دوبارہ کبھی نہیں دکھایا جاتا، صرف اس کے آخری حروف۔',
        required: 'یہ پُر کریں۔',
        save: 'کنکشن محفوظ کریں',
        created: 'جڑ گیا۔ اپنے فراہم کنندہ پر ری ڈائریکٹ URI درج کریں، پھر کنکشن آن کریں۔',
        redirectUri: 'ری ڈائریکٹ URI',
        redirectUriHint: 'یہ پتہ اپنے شناختی فراہم کنندہ پر درج کریں۔',
        secretMasked: 'کلائنٹ سیکرٹ {{masked}}',
        rotated: '{{time}} کو بدلا گیا',
        replaceSecret: 'کلائنٹ سیکرٹ بدلیں',
        replaceTitle: 'کلائنٹ سیکرٹ بدلیں',
        replaceSubmit: 'سیکرٹ بدلیں',
        replaced: 'کلائنٹ سیکرٹ بدل دیا گیا۔',
        endpoints: 'فراہم کنندہ پر ملنے والے اینڈ پوائنٹس',
        status: { draft: 'ابھی آن نہیں', active: 'آن', disabled: 'آف' },
        turnOn: 'آن کریں',
        turnOff: 'آف کریں',
        turnedOn: '{{domain}} کے لیے سنگل سائن آن آن ہے۔',
        turnedOff: '{{domain}} کے لیے سنگل سائن آن آف ہے۔ پاس ورڈ دوبارہ کام کرتے ہیں۔',
        ssoOnly: 'سنگل سائن آن لازمی کریں',
        ssoOnlyHint:
          '{{domain}} کے لوگوں کو سنگل سائن آن استعمال کرنا ہوگا۔ ان کے لیے پاس ورڈ، پاس کیز، سائن اپ اور پاس ورڈ ری سیٹ کام نہیں کریں گے۔',
        ssoOnlyNeedsOn: 'پہلے کنکشن آن کریں۔',
        ssoOnlySaved: '{{domain}} کے لیے اب سنگل سائن آن لازمی ہے۔',
        ssoOnlyOff: '{{domain}} کے لیے پاس ورڈ اور پاس کیز دوبارہ کام کرتے ہیں۔',
        jit: 'سنگل سائن آن سے سائن اِن کرنے والے نئے لوگ',
        jitHint:
          'انہیں خود بخود شامل کرنے کے لیے ایک کردار منتخب کریں، یا صرف مدعو لوگوں کے لیے اسے بند رکھیں۔ دو مرحلہ تصدیق والے کردار منتخب نہیں کیے جا سکتے۔',
        jitOff: 'صرف مدعو لوگ',
        jitSave: 'محفوظ کریں',
        jitSaved: 'نئے لوگ اب {{role}} کے طور پر شامل ہوتے ہیں۔',
        jitCleared: 'اب صرف مدعو لوگ شامل ہو سکتے ہیں۔',
        removeConnection: 'کنکشن ہٹائیں',
        removeConnectionTitle: '{{domain}} کے لیے سنگل سائن آن ہٹائیں؟',
        removeConnectionBody:
          '{{domain}} کے لوگ اب سنگل سائن آن سے سائن اِن نہیں کر سکیں گے۔ اگر ان کا پاس ورڈ تھا تو وہ اسے ری سیٹ کر سکتے ہیں۔',
        removed: '{{domain}} کے لیے سنگل سائن آن ہٹا دیا گیا۔',
      },
      support: {
        title: 'سپورٹ کی رسائی',
        description:
          'Hamnivo سپورٹ آپ کی منظوری کے بعد ہی، محدود وقت کے لیے، اس ورک اسپیس کا ایک حصہ پڑھ سکتی ہے۔ رسائی صرف پڑھنے کے لیے ہے اور ہر بار پڑھنا آپ کے آڈٹ لاگ میں درج ہوتا ہے۔',
        loading: 'سپورٹ کی رسائی لوڈ ہو رہی ہے',
        forbidden: 'سپورٹ کی رسائی ورک اسپیس کے مالکان منظور کرتے ہیں۔',
        pending: 'آپ کے فیصلے کا انتظار',
        active: 'ابھی فعال',
        history: 'پرانی درخواستیں',
        none: 'Hamnivo سپورٹ سے کوئی درخواست نہیں۔',
        from: '{{name}}، Hamnivo سپورٹ',
        asked: '{{time}} کو مانگی',
        reason: 'وجہ: {{reason}}',
        areas: 'وہ کیا پڑھ سکتے ہیں',
        minutes: 'کتنی دیر کے لیے',
        duration: '{{minutes}} منٹ',
        note: 'سپورٹ کے لیے نوٹ',
        approve: 'منظور کریں',
        decline: 'مسترد کریں',
        approved: 'سپورٹ کی رسائی {{time}} تک منظور۔',
        declined: 'درخواست مسترد کر دی گئی۔',
        revoke: 'ابھی منسوخ کریں',
        revokeTitle: 'سپورٹ کی رسائی ابھی منسوخ کریں؟',
        revokeBody: 'ان کا اگلا پڑھنا مسترد ہو جائے گا۔ ضرورت ہو تو وہ دوبارہ مانگ سکتے ہیں۔',
        revoked: 'سپورٹ کی رسائی منسوخ کر دی گئی۔',
        endsAt: '{{time}} کو ختم',
        pickArea: 'کم از کم ایک حصہ منتخب کریں۔',
        states: {
          pending: 'انتظار میں',
          active: 'فعال',
          declined: 'مسترد',
          revoked: 'منسوخ',
          ended: 'ختم',
          expired: 'مدت ختم',
        },
        scopes: {
          configuration: 'کنفیگریشن (اراکین، کردار، برانڈز، ایجنٹس)',
          conversations: 'گفتگو کی فہرست (صرف حیثیت، پیغامات کبھی نہیں)',
          audit: 'آڈٹ لاگ',
        },
      },
    },
    notices: {
      label: 'ورک اسپیس کی اطلاعات',
      supportActive: 'Hamnivo سپورٹ سے {{name}} {{time}} تک {{areas}} پڑھ سکتے ہیں۔',
      supportRecorded: 'ہر بار پڑھنا آپ کے آڈٹ لاگ میں درج ہوتا ہے۔',
      review: 'دیکھیں',
      supportPending: 'Hamnivo سپورٹ نے عارضی رسائی مانگی ہے۔ انتظار میں درخواستیں: {{n}}۔',
      reviewRequest: 'درخواست دیکھیں',
      incident: {
        notice: 'اطلاع',
        degraded: 'سروس سست',
        outage: 'سروس بند',
      },
      since: '{{time}} سے',
      channelDown:
        '{{brand}} کا {{channel}} چینل {{time}} سے کام نہیں کر رہا۔ نئے پیغامات شاید آپ کی ٹیم تک نہ پہنچیں۔',
      channelsDown: 'کام نہ کرنے والے چینل: {{n}}۔ نئے پیغامات شاید آپ کی ٹیم تک نہ پہنچیں۔',
      channelItem: '{{brand}} کا {{channel}} چینل، {{time}} سے',
      fixChannel: 'ٹھیک کریں',
    },
    invitation: {
      title: 'ورک اسپیس میں شامل ہوں',
      description: 'آپ کو Hamnivo کی ایک ورک اسپیس میں مدعو کیا گیا ہے۔',
      signInFirst: 'جس پتے پر دعوت بھیجی گئی تھی اس سے سائن اِن کریں، پھر اسے قبول کریں۔',
      signIn: 'قبول کرنے کے لیے سائن اِن کریں',
      createAccount: 'اکاؤنٹ بنائیں',
      createHint:
        'Hamnivo پر نئے ہیں؟ مدعو پتے سے اکاؤنٹ بنائیں، اس کی تصدیق کریں، پھر دعوت کا لنک دوبارہ کھولیں۔',
      signedInAs: '{{email}} سے سائن اِن',
      accept: 'دعوت قبول کریں',
      accepted: 'آپ {{name}} میں شامل ہو گئے۔',
      missing: 'اس لنک میں کوئی دعوت نہیں ہے۔ اپنی ای میل سے لنک دوبارہ کھولیں۔',
      invalid:
        'یہ دعوت اب درست نہیں ہے۔ شاید اس کی مدت ختم ہو گئی، یہ استعمال ہو چکی، یا کسی اور پتے پر بھیجی گئی تھی۔ نئی دعوت مانگیں۔',
      unverified:
        'پہلے اپنے ای میل پتے کی تصدیق کریں۔ سائن اپ کرتے وقت ہم نے آپ کو ایک لنک بھیجا تھا۔',
      otherAccount: 'کسی اور اکاؤنٹ سے سائن اِن کریں',
    },
  },
  sso: {
    continue: 'سنگل سائن آن سے جاری رکھیں',
    short: 'SSO سے جاری رکھیں',
    email: 'کام کا ای میل پتہ',
    emailHint: 'ہم آپ کو آپ کی تنظیم کے سائن اِن صفحے پر بھیجتے ہیں۔',
    submit: 'جاری رکھیں',
    back: 'پاس ورڈ سے سائن اِن پر واپس جائیں',
    notSetUp:
      'اس پتے کے لیے سنگل سائن آن سیٹ نہیں ہے۔ اپنے پاس ورڈ سے سائن اِن کریں، یا اپنے منتظم سے پوچھیں۔',
    required: 'آپ کی تنظیم اس پتے کے لیے سنگل سائن آن لازمی کرتی ہے۔',
    popupBlocked:
      'آپ کے براؤزر نے سائن اِن ونڈو روک دی۔ Studio کے لیے پاپ اپ کی اجازت دیں، پھر دوبارہ کوشش کریں۔',
    failed: 'سنگل سائن آن مکمل نہیں ہوا۔ دوبارہ کوشش کریں۔',
    errors: {
      sso_email_unverified: 'آپ کے شناختی فراہم کنندہ نے آپ کے ای میل پتے کی تصدیق نہیں کی۔',
      sso_domain_mismatch: 'یہ شناختی فراہم کنندہ صرف اپنے ڈومین کے پتوں سے سائن اِن کرا سکتا ہے۔',
      sso_unverified_local_account:
        'اس پتے کا ایک Hamnivo اکاؤنٹ موجود ہے لیکن اس کی کبھی تصدیق نہیں ہوئی۔ پہلے اس کی تصدیق کریں، پھر سنگل سائن آن استعمال کریں۔',
      sso_unavailable: 'اس پتے کے لیے ابھی سنگل سائن آن دستیاب نہیں ہے۔',
      access_denied: 'آپ کے شناختی فراہم کنندہ پر سائن اِن منسوخ کر دیا گیا۔',
      generic: 'سنگل سائن آن کام نہیں کیا۔ دوبارہ کوشش کریں، یا اپنے منتظم سے رابطہ کریں۔',
    },
    done: 'سائن اِن ہو گیا۔ آپ یہ ونڈو بند کر سکتے ہیں۔',
  },
  reauthMore: {
    otherWays: 'یا کسی اور طریقے سے تصدیق کریں',
    passkey: 'پاس کی استعمال کریں',
    sso: 'سنگل سائن آن استعمال کریں',
    ssoDescription:
      'اس کام کے لیے حال ہی میں سائن ان ضروری ہے۔ اپنی تنظیم کے سنگل سائن آن سے آگے بڑھیں۔ اس صفحے پر آپ کا کام محفوظ رہے گا۔',
  },
  platform: {
    title: 'Hamnivo پلیٹ فارم',
    notOperator: 'یہ کنسول Hamnivo پلیٹ فارم آپریٹرز کے لیے ہے۔',
    notOperatorHint:
      'آپ کا اکاؤنٹ پلیٹ فارم آپریٹر نہیں ہے۔ ورک اسپیس کے کرداروں سے یہاں رسائی نہیں ملتی۔',
    returnToWorkspace: 'ورک اسپیس پر واپس جائیں',
    nav: {
      label: 'پلیٹ فارم',
      tenants: 'ٹیننٹس',
      health: 'سروسز کی حالت',
      support: 'سپورٹ کی رسائی',
      incidents: 'واقعات',
      audit: 'آڈٹ لاگ',
    },
    roles: {
      platform_admin: 'پلیٹ فارم منتظم',
      support_operator: 'سپورٹ آپریٹر',
      platform_viewer: 'پلیٹ فارم ناظر',
    },
    mfaNeeded:
      'سپورٹ کی رسائی مانگنے یا استعمال کرنے کے لیے اکاؤنٹ کی حفاظت میں دو مرحلہ تصدیق آن کریں۔',
    overview: {
      tenants: 'ٹیننٹس',
      active: 'فعال: {{n}}',
      supportActive: 'فعال سپورٹ رسائی',
      supportPending: 'فیصلے کا انتظار',
      aiStops: 'AI کی روکیں',
      providersOff: 'بند کیے گئے فراہم کنندگان',
    },
    tenants: {
      search: 'ٹیننٹس تلاش کریں',
      searchPlaceholder: 'نام یا ہینڈل',
      loading: 'ٹیننٹس لوڈ ہو رہے ہیں',
      empty: 'کوئی ٹیننٹ نہیں ملتا۔',
      columns: {
        name: 'ٹیننٹ',
        status: 'حیثیت',
        region: 'علاقہ',
        aiStops: 'AI کی روکیں',
        support: 'سپورٹ کی رسائی',
      },
      open: '{{name}} کھولیں',
      status: { active: 'فعال', suspended: 'معطل', closing: 'بند ہو رہا ہے' },
      detail: 'ٹیننٹ کی تفصیلات',
      id: 'ٹیننٹ ID',
      created: 'بنایا گیا',
      region: 'علاقہ',
      locale: 'طے شدہ زبان',
      counts: 'ورک اسپیس کے حصے: {{workspaces}} · برانڈز: {{brands}}',
      connectors: 'کنیکٹرز',
      connectorHealth: 'آخری صحت کی جانچ {{time}}',
      noConnectors: 'کوئی کنیکٹر نہیں۔',
      aiStops: 'AI کی روکیں',
      noAiStops: 'AI کہیں بھی رکا ہوا نہیں ہے۔',
      aiStopScope: { tenant: 'پورا ٹیننٹ', brand: 'ایک برانڈ', agent: 'ایک ایجنٹ' },
      providers: 'ماڈل فراہم کنندگان',
      noProviders: 'کوئی فراہم کنندہ کنکشن نہیں۔',
      providerStatus: { active: 'آن', disabled: 'بند' },
      contentNote:
        'پلیٹ فارم آپریٹرز صرف میٹا ڈیٹا دیکھتے ہیں۔ کسٹمرز کے مواد کے لیے سپورٹ کی رسائی ضروری ہے۔',
      noAccess: 'کسٹمرز کے مواد تک رسائی نہیں',
      noAccessHint:
        'پہلے ورک اسپیس کو درخواست منظور کرنی ہوگی۔ رسائی صرف پڑھنے کے لیے اور محدود وقت کی ہوتی ہے۔',
      requestAccess: 'عارضی رسائی مانگیں',
      grants: 'اس ٹیننٹ کی سپورٹ رسائی',
    },
    request: {
      title: '{{name}} تک عارضی رسائی مانگیں',
      description:
        'ورک اسپیس کے مالکان کو ای میل ملتی ہے اور وہ فیصلہ کرتے ہیں۔ ان کی منظوری تک کچھ شیئر نہیں ہوتا۔',
      reason: 'وجہ',
      reasonHint: 'بتائیں کہ آپ کو کیا جانچنا ہے اور کیوں۔ ورک اسپیس یہ دیکھتی ہے۔',
      reasonShort: 'کم از کم 10 حروف لکھیں۔',
      areas: 'آپ کو کیا پڑھنا ہے',
      minutes: 'کتنی دیر',
      submit: 'درخواست بھیجیں',
      sent: 'درخواست بھیج دی گئی۔ ورک اسپیس کے فیصلے کے بعد یہ سپورٹ کی رسائی میں نظر آئے گی۔',
    },
    support: {
      intro: 'ٹیننٹ کے ڈیٹا تک عارضی، صرف پڑھنے والی رسائی کی آپ کی درخواستیں۔',
      loading: 'سپورٹ کی رسائی لوڈ ہو رہی ہے',
      none: 'آپ نے ابھی تک رسائی نہیں مانگی۔',
      expiresIn: 'رسائی {{minutes}} منٹ میں ختم ہوگی',
      endsAt: '{{time}} کو ختم',
      end: 'سیشن ختم کریں',
      ended: 'سپورٹ کی رسائی ختم ہو گئی۔',
      approvedBy: '{{name}} نے منظور کی',
      declinedBy: '{{name}} نے مسترد کی',
      note: 'نوٹ: {{note}}',
      requestAgain: 'دوبارہ مانگیں',
      view: {
        configuration: 'کنفیگریشن دیکھیں',
        conversations: 'گفتگو کی فہرست دیکھیں',
        audit: 'آڈٹ لاگ دیکھیں',
      },
      reading: '{{area}} لوڈ ہو رہا ہے',
      members: 'اراکین',
      roles: 'کردار',
      brands: 'برانڈز',
      agents: 'AI ایجنٹس',
      live: 'لائیو',
      notLive: 'لائیو نہیں',
      conversationsNote: 'صرف حیثیت۔ پیغامات سپورٹ کے ساتھ کبھی شیئر نہیں ہوتے۔',
    },
    health: {
      checked: '{{time}} کو جانچا گیا',
      loading: 'سروسز جانچی جا رہی ہیں',
      services: {
        api: 'API',
        database: 'ڈیٹا بیس',
        valkey: 'کیش اور قطاریں',
        queue: 'پس منظر کی ترسیل',
        connectors: 'کنیکٹرز',
      },
      states: { healthy: 'ٹھیک', degraded: 'سست', down: 'بند' },
      queue: 'انتظار میں ایونٹس: {{pending}} · ناکام ہو رہے: {{failing}}',
      oldest: 'سب سے پرانا انتظار میں: {{seconds}} سیکنڈ',
      connectors: 'کنیکٹرز: {{total}} · توجہ درکار: {{degraded}} · بند: {{disabled}}',
      providers: 'پلیٹ فارم ماڈل کلیدیں',
      configured: 'سیٹ ہے',
      notConfigured: 'سیٹ نہیں',
    },
    incidents: {
      intro: 'واقعات حل ہونے تک ہر ورک اسپیس میں بینر کی صورت میں نظر آتے ہیں۔',
      declare: 'واقعہ کا اعلان کریں',
      loading: 'واقعات لوڈ ہو رہے ہیں',
      none: 'کوئی واقعہ نہیں۔',
      active: 'فعال',
      resolved: '{{time}} کو حل ہوا',
      started: '{{time}} کو شروع ہوا',
      resolve: 'حل کریں',
      resolvedDone: 'واقعہ حل ہو گیا۔ بینر ہٹ گیا۔',
      severity: 'شدت',
      severities: { notice: 'اطلاع', degraded: 'سست', outage: 'بند' },
      titleField: 'عنوان',
      message: 'ورک اسپیسز کے لیے پیغام',
      messageHint: 'بتائیں کہ کس پر اثر ہے اور کیا اب بھی کام کرتا ہے۔',
      tooShort: 'کم از کم 3 حروف لکھیں۔',
      submit: 'واقعہ شائع کریں',
      posted: 'واقعے کا بینر ہر ورک اسپیس میں دکھائی دے رہا ہے۔',
    },
    audit: {
      intro: 'اس کنسول میں کیا گیا ہر کام، اور سپورٹ کی رسائی پر ہر ورک اسپیس کا فیصلہ۔',
      loading: 'پلیٹ فارم آڈٹ لاگ لوڈ ہو رہا ہے',
      empty: 'ابھی کچھ درج نہیں ہوا۔',
      operator: 'آپریٹر',
      workspaceDecision: 'ورک اسپیس کا فیصلہ',
      tenant: 'ٹیننٹ',
      loadMore: 'پرانے اندراجات لوڈ کریں',
    },
  },
  permissionAreas: {
    agency: 'ایجنسی',
    branding: 'برانڈنگ',
    conversations: 'گفتگو',
    visitors: 'وزیٹر',
    inbox: 'ان باکس اور روٹنگ',
    teams: 'ٹیمیں',
    members: 'اراکین',
    roles: 'کردار',
    grants: 'رسائی',
    audit: 'آڈٹ لاگ',
    brands: 'برانڈز',
    widget: 'چیٹ ویجیٹ',
    agents: 'AI ایجنٹس',
    automations: 'آٹومیشن',
    knowledge: 'معلومات',
    tools: 'ٹولز اور اقدامات',
    decisions: 'فیصلے',
    memory: 'کسٹمر میموری',
    commerce: 'آرڈرز اور تجارت',
    analytics: 'رپورٹس',
    billing: 'بلنگ',
    api_keys: 'API کلیدیں',
    webhooks: 'ویب ہکس',
    network: 'اجازت یافتہ ہوسٹس',
    mcp: 'اے آئی معاون (MCP)',
    integrations: 'انٹیگریشنز',
    secrets: 'اسناد',
    extensions: 'ایکسٹینشنز',
    migration: 'درآمد',
    settings: 'ورک اسپیس کی ترتیبات',
    security: 'سیکیورٹی',
    privacy: 'رازداری',
    customers: 'گاہکوں کا ڈیٹا',
    support: 'سپورٹ کی رسائی',
  },
  permissions: {
    agency: {
      read: 'ایجنسی ترتیبات اور کلائنٹ فہرست دیکھیں',
      manage: 'ایجنسی ترتیبات اور آزاد کلائنٹ لنک کا نظم کریں',
    },
    branding: {
      read: 'پورٹل برانڈنگ اور مخصوص ڈومین دیکھیں',
      manage: 'پورٹل برانڈنگ اور تصدیق شدہ مخصوص ڈومین کا نظم کریں',
    },
    conversations: {
      read: 'گفتگو اور کسٹمر کی تاریخ پڑھیں',
      reply: 'کسٹمرز کو جواب دیں',
      note: 'اندرونی نوٹس لکھیں',
      assign: 'گفتگو سونپیں اور منتقل کریں',
      takeover: 'AI یا کسی اور شخص سے گفتگو اپنے ہاتھ میں لیں',
      status: 'گفتگو حل کریں، دوبارہ کھولیں اور ملتوی کریں',
      tag: 'گفتگو کو ٹیگ کریں اور ان کے حسبِ ضرورت فیلڈز بھریں',
      bulk: 'ایک ساتھ کئی گفتگو بدلیں',
      review: 'دوسروں کی گفتگو کا جائزہ لیں اور رہنمائی کریں',
      export: 'گفتگو کے ٹرانسکرپٹ ایکسپورٹ کریں',
    },
    visitors: { block: 'چیٹ کا غلط استعمال کرنے والے وزیٹرز کو بلاک اور ان بلاک کریں' },
    inbox: { manage: 'ان باکس، روٹنگ اور کام کے اوقات سیٹ کریں' },
    teams: { manage: 'ٹیمیں بنائیں اور رکنیت سنبھالیں' },
    members: {
      read: 'ٹیم کے اراکین اور ان کے کردار دیکھیں',
      invite: 'اراکین کو مدعو کریں',
      remove: 'اراکین کو معطل کریں یا ہٹائیں',
    },
    roles: { manage: 'حسبِ ضرورت کردار بنائیں اور بدلیں' },
    grants: { manage: 'اپنے دائرے میں کردار دیں اور واپس لیں' },
    audit: { read: 'آڈٹ لاگ پڑھیں', export: 'آڈٹ لاگ ایکسپورٹ کریں' },
    brands: { manage: 'برانڈز بنائیں اور اجازت یافتہ ویب سائٹس طے کریں' },
    widget: {
      configure: 'چیٹ ویجیٹ سیٹ کریں',
      identity_keys: 'کسٹمر کی شناخت کی تصدیق کرنے والی کلیدیں درج کریں',
    },
    agents: {
      read: 'AI ایجنٹس اور ان کے ورژن دیکھیں',
      manage: 'AI ایجنٹس کے مسودے بدلیں',
      publish: 'AI ایجنٹس شائع کریں یا واپس لیں',
    },
    automations: {
      read: 'آٹومیشن اور انہوں نے کیا کیا، یہ دیکھیں',
      manage: 'آٹومیشن بنائیں، شائع کریں اور بند کریں، ویب سائٹ کے پیغامات سمیت',
    },
    knowledge: { read: 'معلومات کے ذرائع پڑھیں', manage: 'معلومات شامل کریں، بدلیں اور ہٹائیں' },
    tools: {
      read: 'ٹولز، اقدامات کی پالیسیاں، AI کے اقدامات اور سمیولیشن کے نتائج دیکھیں',
      manage: 'ٹولز اور اقدامات کی پالیسیاں سیٹ کریں',
      approve: 'AI ایجنٹس کے تجویز کردہ اقدامات منظور کریں',
    },
    decisions: {
      read: 'روٹنگ اور معیار کے فیصلوں کا جائزہ لیں',
      manage: 'فیصلوں کے معیارات اور حدیں بدلیں',
    },
    memory: {
      read: 'کسٹمر میموری کے ریکارڈ پڑھیں',
      manage: 'میموری ریکارڈ درست یا محدود کریں',
      delete: 'میموری ریکارڈ حذف کریں',
      erase: 'کسی کسٹمر کے بارے میں یاد رکھی ہر چیز مٹائیں',
      export: 'کسی کسٹمر کے بارے میں یاد رکھی ہر چیز ایکسپورٹ کریں',
    },
    commerce: {
      read: 'کارٹس، کوٹیشنز، آرڈرز، ادائیگیاں اور رقم کی واپسیاں دیکھیں',
      carts: { manage: 'گفتگو میں مصنوعات شیئر کریں اور کوٹیشن تیار کریں' },
      orders: { manage: 'آرڈرز پر ترسیل کی تازہ کاری درج کریں' },
      refunds: {
        request: 'کسٹمر کے لیے رقم کی واپسی مانگیں',
        approve: 'رقم کی واپسی منظور یا مسترد کریں',
      },
      exceptions: { resolve: 'فراہم کنندہ سے جانچ کے بعد ادائیگی اور واپسی کے استثنا حل کریں' },
      merchants: { manage: 'تاجر جوڑیں اور ان کی اسناد اور واپسی کے اصول طے کریں' },
    },
    analytics: { read: 'تجزیات اور رپورٹس دیکھیں' },
    billing: {
      read: 'پلان، استعمال اور انوائسز دیکھیں',
      manage: 'پلان، انوائسز اور ادائیگی سنبھالیں',
    },
    api_keys: {
      read: 'API کلیدیں اور ان کا آخری استعمال دیکھیں',
      manage: 'API کلیدیں بنائیں اور منسوخ کریں',
    },
    webhooks: {
      read: 'ویب ہکس اور ان کی ترسیل کا ریکارڈ دیکھیں',
      manage: 'باہر جانے والے ویب ہکس سیٹ کریں',
    },
    network: { manage: 'منتخب کریں کہ Hamnivo کن بیرونی ہوسٹس سے رابطہ کر سکتا ہے' },
    mcp: {
      read: 'Claude جیسے اے آئی معاونین کو Hamnivo کے MCP سرور سے گفتگو، معلومات اور گاہک کی یادداشت پڑھنے دیں',
    },
    integrations: { manage: 'چینلز اور تیسرے فریق کی سروسز جوڑیں' },
    secrets: { manage: 'اسناد محفوظ کریں اور بدلیں' },
    extensions: { manage: 'ایکسٹینشنز انسٹال کریں اور ہٹائیں' },
    migration: {
      review: 'درآمدات، ان کی رپورٹیں اور نمونہ گفتگو دیکھیں',
      run: 'ایکسپورٹ فائلیں اپ لوڈ کریں اور درآمد چلائیں',
      manage: 'درآمد منظور کریں یا واپس لیں',
    },
    settings: { manage: 'ورک اسپیس کی ترتیبات بدلیں' },
    security: { manage: 'سائن اِن، سنگل سائن آن اور سیشن کے اصول سیٹ کریں' },
    privacy: { manage: 'طے کریں کہ گفتگو مٹائے جانے سے پہلے کتنی دیر رکھی جائے' },
    customers: {
      export: 'کسی ایک گاہک کی ساری معلومات ڈاؤن لوڈ کریں، ڈیٹا دیکھنے کی درخواست کے لیے',
      erase: 'کسی ایک گاہک کو ہر جگہ سے مٹائیں، Chatwoot سمیت، مٹانے کی درخواست کے لیے',
    },
    support: { grant: 'Hamnivo سپورٹ کو اس ورک اسپیس تک رسائی دیں' },
  },
};
